import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { SlickCarouselComponent } from 'ngx-slick-carousel';
import { Oferta, Offers, RequestOffers } from '../../../models/oferta';
import { DocumentsType, Parameter } from '../../../models/parameter';
import { Prospect } from '../../../models/prospect';
import { DummisService } from '../../../services/dummis.service';
import { EmitterService } from '../../../services/emitter.service';
import { IntegrationService } from '../../../services/integration.service';
import { ParameterService } from '../../../services/parameter.service';
import { ProspectService } from '../../../services/prospect.service';
import { AppConstants, DialogType, REEMISION_OPCION, TIPO_OFERTA_TC, TipoSolicitudBO } from '../../../shared/constants/app.constants';
import { AlertService, MessageSeverity } from '../../../shared/services/alert.service';
import { ProducService } from '../../../shared/services/productdata.service';
import { FormService } from '../../../shared/services/validation.service';
import { SolicitudService } from '../../../services/solicitud.service';
import { RequestReturnSolicitud } from '../../../models/solicitud';
import { ClientService } from '../../../services/client.service';
import { Cliente, Politica, Producto, ProductoEFEX } from '../../../models/simular';
import { Platform, Row } from '@ionic/angular';
import { AlertPopupService } from '../../../shared/services/alert-popup.service';
import { OnboardingIntegrationService } from '../../../services/onboarding-integration.service';
import { UserService } from '../../../services/user.service';
import { CreateClientCappta, RequestGetCardDetail, RequestGetProducts, RequestValidateReprogramming, ResponseGetCardsClient } from '../../../models/client';
import { ActiveProductResponse, ProductRateResponse } from '../../../models/onboarding-integration';
import { Product } from '../../../models/product';
import { ClientService as ClienteBOService} from '../../../services/ms-backoffice/client.service';
import { OnbDialogComponent } from '../../../shared/components/onb-dialog/onb-dialog.component';
import { SolicitudService as SolicitudBOService } from '../../../services/ms-backoffice/solicitud.service';
import { SolicitudBoSession } from '../../../models/solicitud-bo';
import * as moment from 'moment';

declare const hideMessage: any;
declare const showMessage: any;

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'app-products-list',
    templateUrl: './products-list.component.html',
    styleUrls: ['./products-list.component.css']
})
export class ProductsListComponent implements OnInit {

    slideConfig = {
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        infinite: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    };

    imageRB1A = './assets/images/icon_RB1A.png';
    imageRB2 = './assets/images/icon_RB2.png';
    imageCDD = './assets/images/icon_CDD.png';

    imageBase = './assets/images/';

    count: number;
    prospectoActive: boolean = false;
    ofertaActive: boolean = true;
    btnEscoger: boolean = true;
    loading: boolean = false;

    documents = [];
    products = [];
    productosPerfil = [];
    variablesControl = [];
    variableMensajeReemision: string = '';
    documentTyperForm: string = '';
    documentNumberForm: string = '';
    documentTyperStringForm: string = '';
    nombre1Cliente: string = '';
    nombre2Cliente: string = '';
    emailCliente: string = '';
    fecNacCliente: string = '';
    apellidoMaternoCliente: string = '';
    apellidoPaternoCliente: string = '';
    numerodocumento: string = '';
    max: number;
    valNumber = true;
    searchFlag = false;
    offers: Oferta = new Oferta();
    politica: Politica = new Politica();

    info: string = '';
    person: string = '';
    personResponsive: string = '';
    infopolitica: string = '';
    maxlength: number = 8;
    infoBloqueo: string = '';
    infoSefRsat: string = '';
    slides = [];

    submit: boolean = false;
    politicaCode;
    politicaCodeResponse = '000';

    offerMontMin: number = 0;
    offerMontMax: number = 0;

    FirstNameClient = '';
    SecondNameClient = '';

    flag: string = '1';
    typeInputDocument: string = 'tel';
    modalidadActivacion = [];
    productsSimulation = [];
    UsersAccesFlujo = [];
    conditionAccesFlujo: boolean = false;
    offerCondiguration: Array<Parameter> = [];
    amountcocoValidte: number = 0;
    nameProductCappta: string = '';
	
    pValidacionAgenciaProductos= [];

    validacionEmailT24: boolean = false;

	
	
	
    agencyCode: string = sessionStorage.getItem(AppConstants.Session.AGENCYCODE);
    agencyName: string = sessionStorage.getItem(AppConstants.Session.AGENCYNAME);
    usersessionId: string = sessionStorage.getItem(AppConstants.Session.USERID);
    channelName: string = sessionStorage.getItem(AppConstants.Session.SALES_CHANNEL_DESCRIPTION);
    userRolId: string = sessionStorage.getItem(AppConstants.Session.USERROLID);
    userDocumentNumber: string = sessionStorage.getItem(AppConstants.Session.USERDOCUMENTNUMBER);
    @ViewChild('slickModal') slickModal: SlickCarouselComponent;
    @ViewChild('documentfilter') documentfilter: ElementRef;
    @ViewChild('tcFlujoModal') tcFlujoModal: ModalDirective;
    @ViewChild('tcFlujoModalV2') tcFlujoModalV2: ModalDirective;
    @ViewChild('tcModalValidacionDatosCliente') tcModalValidacionDatosCliente: ModalDirective;

    modalCocoCappta: BsModalRef;
    validationReprograming: boolean = false;
    clientName: string = '';
    listPerfilsRestrictionPEP = [];
    productosHiddenPolitica = [AppConstants.Products.REPROTC, AppConstants.Products.REPROSEF];
    listAgenciasPermitidasVentaTC = [];

    listTypeOfferTC = [];
    listSubProductTC = [];
    listTcRemisionReactivacionEspecial = [];
    listOptionReemision = [];
    offersearchdate: string = '';
    currentTcFlujo: any = {};
    currentTcFlujoV2: any = {};
    currentValidacionDatosCliente: any = {};
    currentRowTcFlujo: any = null;
    rangoDiasAtrasoTC = [];
    validGetDataEfex: boolean = true;
    profilesConsultSimulation = [];
    productsAllow = [];
    currentValidacionEmailT24: any={};
    productIncLine: Product[] = [];
    bsModalRef: BsModalRef;
    excludeValidationEmailIL = [AppConstants.RolesCode.CALLCENTER, AppConstants.RolesCode.PROVEEDORCALLCENTER];

    cardCambioProd = [];
    actDesCard = '';
    actNroCard = '';
    newDesCard = '';
    valCamProd = '';
    nroSolicitud:string = '';

    constructor(
        private formService: FormService,
        private formBuilder: FormBuilder,
        private prospectService: ProspectService,
        private alertaService: AlertService,
        private router: Router,
        private emitterService: EmitterService,
        private parameterService: ParameterService,
        private integrationService: IntegrationService,
        private data: ProducService,
        private datePipe: DatePipe,
        private route: ActivatedRoute,
        private solicitudService: SolicitudService,
        private clientService: ClientService,
        private platform: Platform,
        private onboardingIntegrationService: OnboardingIntegrationService,
        private userService: UserService,
        private clienteBOService: ClienteBOService,
        private bsModalService: BsModalService,
        private solicitudBOService: SolicitudBOService,

    ) {

        this.router.events.subscribe((evt) => {
            if (evt instanceof NavigationEnd) {
                // trick the Router into believing it's last link wasn't previously loaded
                this.router.navigated = false;
                // if you need to scroll back to top, here is the right place
                window.scrollTo(0, 0);
            }
        });
    }

    @ViewChild('prototipoModal') prototipoModal: ModalDirective;

    prospectForm: FormGroup;
    //prospectForm2: FormGroup; jpadilla

    messageErrors = {
        documenType: '',
        documentNumber: '',
        lastname: '',
        name: '',
        cellphone: '',
        email: '',
        consentimiento: ''
    };

    async ngOnInit() {
        //this.obtenerVariablesControl();
        this.emitterService.sendMessage('/productsList');
        sessionStorage.removeItem(AppConstants.ObjectCliente.CLIENTE);
        this.createForm();
        this.getDocuments();
        //this.getProducts(AppConstants.ParameterCode.PRODUCTOS)
        //this.getProductsSimulation(AppConstants.ParameterCode.SIMULACIONPYOFF)
        this.slides = [];
        this.data.closEntidad();
        this.obtenerModosActivacion();

        await this.platform.ready();
        await this.GetParameters([
            AppConstants.ParameterCode.USER_TRANSACCION,
            AppConstants.ParameterCode.SUB_PRODUCS,
            AppConstants.ParameterCode.SIMULACIONPYOFF,
            AppConstants.ParameterCode.VARIABLE_CONTROL_HEADER,
            AppConstants.ParameterCode.OFFER_DINAMICA,
            AppConstants.ParameterCode.PRODUCTOS_PERFIL,
            AppConstants.ParameterCode.COCO_PARAMETROS,
            AppConstants.ParameterCode.RESTRICCION_VENTA_CLIENT_PEP,
            AppConstants.ParameterCode.VALIDACION_VENTA_TC_AGENCIA,
            AppConstants.ParameterCode.TIPO_OFERTA_TC,
            AppConstants.ParameterCode.SUB_PRODUCTOS_TC,
            AppConstants.ParameterCode.TC_REMISION_REACTIVACION_ESPECIAL,
            AppConstants.ParameterCode.REEMISION_OPCIONES,
            AppConstants.ParameterCode.DIAS_ATRASO_TC,
            AppConstants.ParameterCode.ROLES_BLOQUEAR_SIMULACION,
            AppConstants.ParameterCode.CAMBIO_PRODUCTO_TC,
			AppConstants.ParameterCode.VALIDACION_AGENCIA_PRODUCTOS,
																	
        ]);

        if (sessionStorage.getItem(AppConstants.FlagIntent.FLAG_APP) != null) {
            sessionStorage.setItem(AppConstants.FlagIntent.FLAG_APP, '');
            let docNumber = sessionStorage.getItem(AppConstants.FlagIntent.FLAG_DNI);
            this.documentNumberForm = docNumber;

            var model = new RequestReturnSolicitud();
            model.documentType = '1';
            model.documentNumber = docNumber;
            this.verificarSolicitudInProgrres(model);
        }
    }

    createForm() {
        this.prospectForm = this.formBuilder.group({
            documenType: 1,
            documentNumberForm: '',
            documentNumber: ['', Validators.required],
            lastname: ['', Validators.required],
            name: ['', Validators.required],
            cellphone: ['', Validators.compose([
                Validators.required,
                Validators.pattern('^9[0-9]{8}$')
            ])],
            email: ['', Validators.compose([
                Validators.required,
                Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
            ])],
            consentimiento: [false, Validators.requiredTrue]
        });
    }

    evaluateError(formControlName: string, label: string): boolean {

        var Errores = this.prospectForm.get(formControlName).errors;
        var Dirty: boolean = this.prospectForm.get(formControlName).dirty;
        var Touched: boolean = this.prospectForm.get(formControlName).touched;

        if (formControlName != null) {
            if (Errores != null) {
                if ((Dirty && Touched) || this.submit) {
                    if (this.flag == '0') {
                        if (this.prospectForm.value['email'] == null && this.prospectForm.value['cellphone'] == null && this.prospectForm.value['name'] == null && this.prospectForm.value['lastname'] == null && this.prospectForm.value['consentimiento'] == null) {
                            if (Errores['required'] && label != '') {
                                this.messageErrors[formControlName] = 'Ingrese ' + label + '';
                            }

                        }
                    } else {

                        this.messageErrors[formControlName] = '';
                        return false;
                    }

                    if (Errores['required'] && label != '' && formControlName == 'consentimiento') {
                        this.messageErrors[formControlName] = 'Acepte ' + label + '';
                    }
                    if (Errores['pattern'] && formControlName == 'email') {
                        this.messageErrors[formControlName] = 'Ingrese un correo válido, Ejm: nombre@dominio.com';
                    }
                    if (Errores['maxlength'] && formControlName == 'documentNumber') {
                        this.messageErrors[formControlName] = 'Se supera el máximo de ' + this.maxlength + ' dígitos.';
                    }
                    if (Errores['minlength'] && formControlName == 'documentNumber') {
                        this.messageErrors[formControlName] = 'Ingrese los ' + this.maxlength + ' dígitos';
                    }
                    if (Errores['minlength'] && formControlName == 'cellphone') {
                        this.messageErrors[formControlName] = 'Ingrese los 9 dígitos.';
                        return true;
                    }
                    if (Errores['pattern'] && formControlName == 'cellphone') {
                        this.messageErrors[formControlName] = 'Debe empezar con 9';
                    }
                    //por validar
                    return true;
                }
            }
        }
        return false;
    }

    sendPrototipo() {
        this.flag = '0';
        this.submit = true;
        if (this.prospectForm.valid) {
            var model = new Prospect();
            model.prosApellidos = this.prospectForm.value['lastname'];
            model.prosCelPhone = this.prospectForm.value['cellphone'];
            model.prosConsenmiento = this.unparseCheckBox(this.prospectForm.value['consentimiento']);
            model.prosDocumentNumber = this.prospectForm.value['documentNumber'];
            model.prosDocumenTYpe = this.prospectForm.value['documenType'];
            model.prosEmail = this.prospectForm.value['email'];
            model.prosNombres = this.prospectForm.value['name'];
            model.prosDniVendedor = this.userDocumentNumber;
            model.prosAgenciaVendedor = this.agencyName;
            this.saveProspect(model);
        }
    }

    returnSearchProduct() {
        this.flag = '1';
        this.prospectoActive = false;
        this.prototipoModal.hide();
        this.documentNumberForm = '';
        this.documentTyperForm = this.documents[0]['code'];
        this.max = this.documents[0]['length'];
    }

    LimpiarDNI() {
        this.documentNumberForm = '';
        this.documentTyperForm = this.documents[0]['code'];
        this.max = this.documents[0]['length'];
    }

    unparseCheckBox(id: boolean) {
        if (id) {
            return 1;
        } else {
            return 0;
        }
    }

    saveProspect(prospect: Prospect) {
        this.loading = true;
        this.prospectService.createProspect(prospect).subscribe((response => {
            //this.alertaService.showMessage(AppConstants.TitleModal.PROSPECT_ADD_TITLE, AppConstants.MessageModal.PROSPECT_ADD_MESSAGE_OK, MessageSeverity.success);
            this.loading = false;
            this.prototipoModal.show();
        }),
            (error: HttpErrorResponse) => {
                this.alertaService.showMessage(AppConstants.TitleModal.PROSPECT_ADD_TITLE, error.error.messages, MessageSeverity.error);
                this.loading = false;
            });
        this.Clear();
        this.ClearFormProspect();
    }

    async selectProduct(row) {

        if (this.profilesConsultSimulation.length > 0) {
            if (this.productsAllow.filter(f => f === row.codigoproducto).length == 0) {
                this.alertaService.showMessage(AppConstants.TitleModal.CONSULT_OFFER_RUO, AppConstants.MessageModal.MESSAGE_USER_CONSULT, MessageSeverity.error);
                this.loading = false;
                return;
            }
        }

        if (this.productosPerfil && this.productosPerfil.filter(x => x.tabDetCode006 === row.codigoproducto).length > 0) {
            if (await this.validateFlujoAcces(row.codigoproducto)) {
                if (row.codigoproducto == AppConstants.Products.REPROSEF ||
                    row.codigoproducto == AppConstants.Products.REPROTC) {
                    this.loading = true;

                    var model = new RequestValidateReprogramming();
                    model.documentType = this.documentTyperForm;
                    model.documentNumber = this.documentNumberForm;
                    model.productId = row.codigoproducto;
                    model.baseCode = row.codprodBase;

                    await this.clientService.getValidationReprograming(model)
                        .toPromise().then((response) => {
                            this.validationReprograming = response.status;
                            this.loading = false;
                        },
                            (error: HttpErrorResponse) => {
                                this.alertaService.showMessageSimulator(AppConstants.TitleModal.VALIDATE_REPROGRAMMING, error.error.messages, MessageSeverity.error);
                                this.loading = false;
                            });

                    if (this.validationReprograming && row.codigoproducto == AppConstants.Products.REPROTC && row.codprodBase.toUpperCase().includes('ALIVIO')) {
                        let paramDiasAtraso = this.rangoDiasAtrasoTC.find(x => x.tabDetCode001 == '01');
                        if (paramDiasAtraso) {
                            let diasMin = Number(paramDiasAtraso.tabDetCode005);
                            let diasMax = Number(paramDiasAtraso.tabDetCode006);
                            if ((row.diasMora >= diasMin && row.diasMora <= diasMax))
                                this.validationReprograming = true;
                            else {
                                let ERROR_REPROGRAMACION_TC = AppConstants.MessageModal.ERROR_REPROGRAMACION_TC;
                                ERROR_REPROGRAMACION_TC = ERROR_REPROGRAMACION_TC.replace('[DIAS_MORA]', row.diasMora.toString());
                                ERROR_REPROGRAMACION_TC = ERROR_REPROGRAMACION_TC.replace('[DIAS_MIN]', diasMin.toString());
                                ERROR_REPROGRAMACION_TC = ERROR_REPROGRAMACION_TC.replace('[DIAS_MAX]', diasMax.toString());
                                this.alertaService.showMessage(AppConstants.TitleModal.VALIDATE_REPROGRAMMING, ERROR_REPROGRAMACION_TC, MessageSeverity.error);
                                this.loading = false;
                                return;
                            }
                        }
                    }

                    if (this.validationReprograming == false) {
                        return;
                    } else {
                        let variable = this.valdiateContinueSimulation(row.codigoproducto);
                        if (variable) {
                            if (this.products.filter(f => f.tabDetCode001 == row.codigoproducto && f.tabDetCode004 == AppConstants.StateFlag.Activo && row.codigoproducto != AppConstants.Products.CAMBPROD && f.tabDetState == AppConstants.StateFlag.ActivoString).length > 0) {
                                if (this.modalidadActivacion.filter(f => f.tabDetCode001 == row.modoactivacion).length > 0) {
                                    await this.continueSimulator(row);
                                } else {
                                    this.alertaService.showMessage(AppConstants.TitleModal.CONSULT_OFFER_RUO, AppConstants.MessageModal.PRODUCT_ERROR_MODALIDAD_ACTIVACION, MessageSeverity.error);
                                }
                            } else {
                                await this.continueSimulator(row);
                            }
                        } else {
                            return;
                        }
                    }
					
                } else {
                    let variable = this.valdiateContinueSimulation(row.codigoproducto);
                    if (variable) {
                      if (this.products.filter(f => f.tabDetCode001 == row.codigoproducto &&
                        f.tabDetCode004 == AppConstants.StateFlag.Activo &&
                        row.codigoproducto != AppConstants.Products.CAMBPROD &&
                        f.tabDetState == AppConstants.StateFlag.ActivoString).length > 0) {
                            if (this.modalidadActivacion.filter(f => f.tabDetCode001 == row.modoactivacion).length > 0) {
                                await this.continueSimulator(row);
                            } else {
                                this.alertaService.showMessage(AppConstants.TitleModal.CONSULT_OFFER_RUO, AppConstants.MessageModal.PRODUCT_ERROR_MODALIDAD_ACTIVACION, MessageSeverity.error);
                            }
                        } else {
                            //VALIDAR TC
                            if (row.codigoproducto == AppConstants.Products.CAPTACION) {
                                this.loading = true;
                                //Validar tipo de oferta permitida
                                if (!(this.listTypeOfferTC.filter(f => f.tabDetCode001.trim() == row.IND_CLIE && f.tabDetCode003 == AppConstants.StateFlag.Activo && f.tabDetState == AppConstants.StateFlag.ActivoString).length > 0)) {
                                    let typeTc = this.listTypeOfferTC.find(f => f.tabDetCode001.trim() == row.IND_CLIE);
                                    let menssageErrorTypeTC = (typeTc != undefined || typeTc != null) ? typeTc.tabDetCode006 : AppConstants.MessageModal.ERROR_VALIDACION_TC_GENERIC;
                                    this.alertaService.showMessage(AppConstants.TitleModal.VALIDACION_TIPO_OFERTA, menssageErrorTypeTC != null && menssageErrorTypeTC != '' ? menssageErrorTypeTC : AppConstants.MessageModal.ERROR_VALIDACION_TC_GENERIC, MessageSeverity.error);
                                    this.loading = false;
                                    return;
                                }

                                //Validar Agencias permitidas
                                if (this.listAgenciasPermitidasVentaTC.filter(f => f === this.agencyCode).length > 0) {
                                    let cards: ResponseGetCardsClient[] = [];

                                    //Obtener tarjetas del cliente
                                    try {
                                        cards = await this.clientService.getCardsClient("", "TC", this.numerodocumento, this.documentTyperForm).toPromise();
                                    } catch (error) {
                                        this.alertaService.showMessage(AppConstants.TitleModal.CONSULT_PRODUCTS, AppConstants.MessageModal.MESSAGE_ERROR_CONSULT_PRODUCTS, MessageSeverity.error);
                                        this.loading = false;
                                        return false;
                                    }
									
                                    //Validar tipo de oferta de la tarjeta
                                    //01: Pre-emisión (DNI)
                                    if (row.IND_CLIE === TIPO_OFERTA_TC.PRE_EMISION) {
                                        if (cards && cards.length > 0)
                                            this.alertaService.showMessage(AppConstants.TitleModal.VALIDACION_TIPO_OFERTA, AppConstants.MessageModal.MENSAJE_TIPO_OFERTA, MessageSeverity.error);
                                        else {
                                            await this.continueSimulator(row);
                                            return;
                                        }
                                    }
                                    else {
                                        //02: Reactivación Especial
                                        //03: Reemisión Especial
                                        this.currentRowTcFlujo = row;

                                        //Si el cliente tiene tarjetas se valida la deuda
                                        if (cards && cards.length > 0) {
                                            const card = cards[0];
                                            if (cards.length > 1) {
                                                const flujo = this.listOptionReemision.filter(f => f.tabDetCode001 == REEMISION_OPCION.OPCION3)[0];
                                                this.flujoTcRemisionReactivacionV2(flujo);
                                            } else {
                                                //Obtener detalle de la primera tarjeta del cliente
                                                await this.clientService.getDetailTCByNumber({
                                                    contractNumber: card.contrato,
                                                    ignoreMovements: true,
                                                } as RequestGetCardDetail).toPromise().then(cardDetail => {
                                                    const deuda = Number(cardDetail.debtTotalTc);

                                                    //Se obtiene el flujo de acuerdo a la deuda del cliente
                                                    const flujo = this.listTcRemisionReactivacionEspecial.filter(f => f.tabDetCode001 != TIPO_OFERTA_TC.PRE_EMISION && (deuda >= Number(f.tabDetCode003) && deuda <= Number(f.tabDetCode004)))[0];

                                                    //Se procede a ejecutar el flujo que aplica segun la deuda
                                                    this.flujoTcRemisionReactivacion(flujo, cardDetail, card);
                                                });
                                            }
                                        } else {
                                            //Si el cliente no tiene tarjetas se usa el flujo 01: SIN TC
                                            const flujo = this.listTcRemisionReactivacionEspecial.filter(f => f.tabDetCode001 == TIPO_OFERTA_TC.PRE_EMISION)[0];
                                            //row.typeOfferTC = TIPO_OFERTA_TC.PRE_EMISION;
                                            this.flujoTcRemisionReactivacion(flujo);
                                        }
                                    }
                                }
                                else {
                                    this.alertaService.showMessage(AppConstants.TitleModal.CONSULT_OFFER_RUO, AppConstants.MessageModal.PRODUCT_ERROR_AGENCY_NO_AUTORIZADO, MessageSeverity.error);
                                }
                                this.loading = false;
                            }
                            else {
                              if (row.codigoproducto == AppConstants.Products.IL || row.codigoproducto == AppConstants.Products.CAMBPROD) {
                                    const documentType: DocumentsType = this.documents.find(f => f.code === this.documentTyperForm);
                                    this.loading = true;
                                    this.clientService.getClientT24(documentType.t24, this.numerodocumento).subscribe((response) => {
                                      this.loading = false;
                                      this.emailCliente = response.correo;
                                      const fechanac = moment(response.fechaNacimiento, 'YYYY-MM-DD').format('DD/MM/YYYY')
                                      this.fecNacCliente = fechanac;
                                      if(this.excludeValidationEmailIL.includes(this.userRolId)){
                                        this.continueSimulator(row);
                                      } else {
                                        if(this.emailCliente && this.emailCliente.length>0){
                                          this.continueSimulator(row);
                                        }else{
                                          this.showModalValidationEmail();
                                        }
                                      }
                                    },
                                    (error: HttpErrorResponse) => {
                                        this.alertaService.showMessage('Error', error.error.messages, MessageSeverity.error);
                                        this.loading = false;
                                    });
                                }
                                else{
                                    await this.continueSimulator(row);
                                }
                            }
                        }
                    } else {
                        return;
                    }
                }
            } else {
                return;
            }
        } else {
            this.alertaService.showMessage(AppConstants.TitleModal.CONSULT_OFFER_RUO, AppConstants.MessageModal.PRODUCT_ERROR_PERFIL_NO_AUTORIZADO, MessageSeverity.error);
            return;
        }
    }

    showModalValidationEmail() {
      const initialState = {
        type: DialogType.Warinng,
        title: AppConstants.TitleModal.VALIDACION_EMAIL_T24,
        subTitle: 'Cliente no cuenta con correo!',
        message: AppConstants.MessageModal.MESSAGE_VALIDACION_EMAIL_T24,
        buttons: [
          { text: 'Aceptar', width: '50', handler: () => { this.bsModalRef.hide(); } }
        ]
      };
      this.bsModalRef = this.bsModalService.show(OnbDialogComponent, {
        initialState,
        class: "modal-dialog-centered",
        backdrop: "static",
        keyboard: false
      } );
    }

    flujoTcRemisionReactivacion(flujo, cardDetail = null, card = null): void {
        this.currentTcFlujo = Object.assign({}, flujo);
        this.currentTcFlujo.previousCard = card;
        this.currentTcFlujo.previousCardDetail = cardDetail;

        if (cardDetail && card)
            this.currentTcFlujo.tabDetCode009 = this.currentTcFlujo.tabDetCode009
                .replace("[SALDO]", cardDetail.debtTotalTcFormat.replace("-", ""))
                .replace("[CONTRATO]", card.contrato);

        this.tcFlujoModal.show();
    }

    flujoTcRemisionReactivacionV2(flujo): void {
        this.currentTcFlujoV2 = Object.assign({}, flujo);
        this.currentTcFlujoV2.tabDetCode002 = this.currentTcFlujoV2.tabDetCode002

        this.tcFlujoModalV2.show();
    }

    cancelTcFlujoModal(): void {
        this.currentTcFlujo = {};
        this.currentRowTcFlujo = null;
        this.tcFlujoModal.hide();
    }

    cancelTcFlujoModalV2(): void {
        this.currentTcFlujoV2 = {};
        this.tcFlujoModalV2.hide();
    }

    flujoValidacionDatosCliente(titulo, mensajeAlerta): void {
        this.currentValidacionEmailT24.titulo = titulo
        this.currentValidacionEmailT24.mensajeAlerta = mensajeAlerta
        this.tcModalValidacionDatosCliente.show();
        this.loading = false;
    }

    cancelValidacionDatosCliente(): void {
        this.currentValidacionEmailT24 = {};
        this.tcModalValidacionDatosCliente.hide();
    }

    validateTcFlujoConfirm(): boolean {
        if (this.currentTcFlujo) {
            if (this.currentTcFlujo.tabDetCode010 || this.currentTcFlujo.tabDetCode011) {
                if (!this.currentTcFlujo.optionSelected) {
                    return true;
                }
            }
        }
        return false;
    }
    async confirmTcFlujoModal() {


        if (this.currentTcFlujo && this.currentTcFlujo.tabDetCode005 == "1")
            await this.continueSimulator(this.currentRowTcFlujo);
        else
            this.cancelTcFlujoModal();
    }

    async getDiasMora(contractNumber: string): Promise<number> {
        let dias = 0;
        let model = {
            contractNumber: contractNumber.slice(-12),
            anyBic: '0001',
            bicFi: '0001',
            userId: ''
        }
        await this.onboardingIntegrationService.getDataMoraByContract(model).toPromise().then((response) => {
            if (response && Object.keys(response).length > 0) {
                let item = response.retrieveCreditCardBillingTransactionDefaultInformationResponse;
                if (item) {
                    dias = Number(item.obligation.agreement.validityPeriod.numberOfDays);
                }
            }
        },
            (error: HttpErrorResponse) => {
                this.alertaService.showMessageSimulator(AppConstants.TitleModal.VALIDATE_REPROGRAMMING, error.error.messages, MessageSeverity.error);
            });
        return dias;
    }

    getDocuments() {
        this.loading = true;
        this.parameterService.getDocuments().subscribe((response) => {
            this.documents = response;
            this.documentTyperForm = this.documents[0]['code'];
            this.max = this.documents[0]['length'];
            this.maxlength = this.documents[0]['length'];
            this.loading = false;
            this.validateNavigateWithDataClient();
        },
            (error: HttpErrorResponse) => {
                this.loading = false;
            });
    }

    getProducts(code: number) {
        this.loading = true;
        this.parameterService.getParameters(code).subscribe((response) => {
            this.products = response;
            this.loading = false;
        },
            (error: HttpErrorResponse) => {
                this.loading = false;
            });
    }

    searchOffer() {
        this.formService.resetForm(this.prospectForm);
        this.prospectForm.controls['documenType'].setValue(this.documentTyperForm);
        let client: DocumentsType = this.documents.find(f => f.code === this.documentTyperForm);
        if (this.documentNumberForm.length == client.length) {
            this.documentTyperStringForm = client.name;
            var model = new RequestReturnSolicitud();
            model.documentType = client.code;
            model.documentNumber = this.documentNumberForm;
            this.verificarSolicitudInProgrres(model);
            this.documentfilter.nativeElement.blur();

        }
    }

    searchCE() {
        this.formService.resetForm(this.prospectForm);
        this.prospectForm.controls['documenType'].setValue(this.documentTyperForm);
        let document: DocumentsType = this.documents.find(f => f.code === this.documentTyperForm);
        if (document.name.toUpperCase().includes('C.E')
            || document.name.toUpperCase().includes('CE')
            || document.name.toUpperCase().includes('CARNE')
            || document.name.toUpperCase().includes('EXTRANJERIA')) {
            //this.callGetOffers(document.code, this.documentNumberForm);

            //Call Validate Solicitud En progreso.
            var model = new RequestReturnSolicitud();
            model.documentType = document.code;
            model.documentNumber = this.documentNumberForm;
            this.verificarSolicitudInProgrres(model);
            this.documentfilter.nativeElement.blur();
        }
    }

    removeSpacesDocument() {
        this.documentNumberForm = this.documentNumberForm.replace(/ /g, ' ');
    }

    onlyNumber() {
        if (this.valNumber == true) {
        } else {
            this.documentNumberForm = this.documentNumberForm.replace(/[^a-zA-Z0-9_-]/g, '');
        }
    }

    typeOperation() {
        this.infopolitica = '';
        this.Clear();
        let document = this.documents.find(f => f.code === this.documentTyperForm);
        this.max = document.length;
        this.prospectForm.patchValue({
            documenType: this.documentTyperForm
        });
        this.documentNumberForm = '';
        if (document.name.toUpperCase().includes('C.E')
            || document.name.toUpperCase().includes('CE')
            || document.name.toUpperCase().includes('CARNE')
            || document.name.toUpperCase().includes('EXTRANJERIA')) {
            this.valNumber = false;
            this.typeInputDocument = 'text';
        } else {
            this.valNumber = true;
            this.typeInputDocument = 'tel';
        }

    }

    myFunction() {
        this.documentNumberForm = this.documentNumberForm.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
    }

    //typeOperation2() {
    //    this.infopolitica = '';
    //    this.Clear();
    //    let document = this.documents.find(f => f.code === this.documentTyperForm);
    //    this.max = document.length;
    //    this.prospectForm.patchValue({
    //        documenType: this.documentTyperForm
    //    });
    //    this.documentNumberForm = '';
    //    if (document.name.toUpperCase().includes("C.E")
    //        || document.name.toUpperCase().includes("CE")
    //        || document.name.toUpperCase().includes("CARNE")
    //        || document.name.toUpperCase().includes("EXTRANJERIA")) {
    //        this.valNumber = false;
    //    } else
    //        this.valNumber = true;
    //}


    callGetOffers(documentType: string, documenNumber: string) {
        this.Clear();
        this.infopolitica = '';
        this.infoBloqueo = '';
        this.infoSefRsat = '';
        this.loading = true;
        var offerRequest = new RequestOffers();
        var responseFilter = new Oferta();
        offerRequest.RetrieveCustomerOfferProcedure.Customer.RepresentativeOfCustomer.Person.PersonIdentification.TypeOfIdentification = documentType;
        offerRequest.RetrieveCustomerOfferProcedure.Customer.RepresentativeOfCustomer.Person.PersonIdentification.IdentityCardNumber = documenNumber;
        offerRequest.RetrieveCustomerOfferProcedure.CommunicationChannel.Type = AppConstants.Configuration.CHANNEL_DEFAULT;
        offerRequest.RetrieveCustomerOfferProcedure.CommunicationChannel.ExposedPointOfInteraction.GroupIdentifier = AppConstants.Configuration.ENTERPRISE_DEFAULT;
        this.integrationService.getOffersNew(documentType, documenNumber).subscribe((response) => {
            // this.integrationService.getOffers(offerRequest).subscribe((response) => {

            responseFilter.RetrieveCustomerOfferProcedureResponse.Offers = response.RetrieveOfferManagementGetOffersResponse.Offers;
            this.offersearchdate = response.OfferSearchDate;
            // responseFilter.RetrieveCustomerOfferProcedureResponse.Offers = response.RetrieveCustomerOfferProcedureResponse.Offers;
            this.offers = responseFilter;


            let total = this.offers.RetrieveCustomerOfferProcedureResponse.Offers.length;
            let cont = 0;
            if (total > 0) {

                for (let k in this.offers.RetrieveCustomerOfferProcedureResponse.Offers) {

                    if (this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].Show === "NO") {
                        cont++;
                    }
                }
            }
            if (total == cont) {
                this.prospectForm.controls['documentNumber'].setValue(this.documentNumberForm);
                this.prospectoActive = true;
                this.loading = false;
                return;
            }
            //

            if (this.offers.RetrieveCustomerOfferProcedureResponse.Offers.length > 0) {
                let client: DocumentsType = this.documents.find(f => f.code === this.documentTyperForm);
                this.info = 'Información del Producto';
                var secondName = this.offers.RetrieveCustomerOfferProcedureResponse.Offers[0].Customer.RepresentativeOfCustomer.Person.PersonIdentification.PersonName.MiddleName == null ? '' : ' ' + this.offers.RetrieveCustomerOfferProcedureResponse.Offers[0].Customer.RepresentativeOfCustomer.Person.PersonIdentification.PersonName.MiddleName;
                var clienName = this.offers.RetrieveCustomerOfferProcedureResponse.Offers[0].Customer.RepresentativeOfCustomer.Person.PersonIdentification.PersonName.GivenName + ' ' + secondName + ' ' + this.offers.RetrieveCustomerOfferProcedureResponse.Offers[0].Customer.RepresentativeOfCustomer.Person.PersonIdentification.PersonName.LastName + ' ' + this.offers.RetrieveCustomerOfferProcedureResponse.Offers[0].Customer.RepresentativeOfCustomer.Person.PersonIdentification.PersonName.SecondLastName;

                this.apellidoPaternoCliente = this.offers.RetrieveCustomerOfferProcedureResponse.Offers[0].Customer.RepresentativeOfCustomer.Person.PersonIdentification.PersonName.LastName;
                this.apellidoMaternoCliente = this.offers.RetrieveCustomerOfferProcedureResponse.Offers[0].Customer.RepresentativeOfCustomer.Person.PersonIdentification.PersonName.SecondLastName;
                this.nombre1Cliente = this.offers.RetrieveCustomerOfferProcedureResponse.Offers[0].Customer.RepresentativeOfCustomer.Person.PersonIdentification.PersonName.GivenName + secondName;
                this.numerodocumento = documenNumber;//response.RetrieveOfferManagementGetOffersResponse.Offers[0].Customer.RepresentativeOfCustomer.Person.PersonIdentification.IdentityCardNumber;
                // this.numerodocumento = response.RetrieveCustomerOfferProcedureResponse.Offers[0].Customer.RepresentativeOfCustomer.Person.PersonIdentification.IdentityCardNumber;

                this.FirstNameClient = this.offers.RetrieveCustomerOfferProcedureResponse.Offers[0].Customer.RepresentativeOfCustomer.Person.PersonIdentification.PersonName.GivenName;
                this.SecondNameClient = secondName;

                this.clientName = this.apellidoPaternoCliente + ' ' + this.apellidoMaternoCliente + ' ' + this.FirstNameClient;
                this.person = '<b>' + client.name + ' :</b> ' + this.documentNumberForm + ' - <b>Cliente:</b> ' + clienName;
                this.personResponsive = clienName + '<br><strong>' + client.name + ' :</strong> ' + this.documentNumberForm;
                this.validarPolitica(this.offers.RetrieveCustomerOfferProcedureResponse.Offers[0].CustomerOffer.OfferedAgreement.Account[0].BaseCurrency);

            } else {
                this.prospectForm.controls['documentNumber'].setValue(this.documentNumberForm);
                this.prospectoActive = true;
                this.loading = false;
            }
            //this.loading = false;
        },
            (error: HttpErrorResponse) => {
                this.loading = false;
                this.alertaService.showMessage(AppConstants.TitleModal.CONSULT_OFFER_RUO, error.error.moreInformation, MessageSeverity.error);
            });
    }

    getPropertiesOffer(codeRUO: string, posicion: string, additionalProperties: { Key: string, Value: number }[]) {
        let array: Array<string> = [];
        let orderArray = this.offerCondiguration.filter(f => f.tabDetCode001 == codeRUO).sort((a, b) => (a.tabDetCode003 < b.tabDetCode003 ? -1 : 1));
        var oferta = this.offers.RetrieveCustomerOfferProcedureResponse.Offers[posicion] as Offers;

        if(codeRUO == AppConstants.Products.CAMBPROD){
          let codCambio = '';
          if (oferta.AditionalInformationList.AditionalInformation.length > 0) {
              oferta.AditionalInformationList.AditionalInformation.forEach(p => {
                  let property = p;
                  if (property.Key=='COD_CAMBIO_PROD'){
                    if(property.Value != null){
                        codCambio = this.formatPad(property.Value,4);
                        this.valCamProd = codCambio;
                    }
                  }
              });
          }
          if(this.valCamProd=='' || this.valCamProd==null){
            this.alertaService.showMessage('Cambio Producto :: Error', 'Error al obtener el codigo de producto.',MessageSeverity.error);
          } else {
            let arrCard = this.cardCambioProd.filter(f => f.tabDetCode001 == codCambio);
            arrCard.forEach(c => {
              this.newDesCard = c.tabDetCode006
          });
          }
          if(this.newDesCard=='' || this.newDesCard==null){
              this.alertaService.showMessage('Cambio Producto :: Error', 'Error al obtener el nuevo producto.',MessageSeverity.error);
          }
          
        }

        var arrayProperties = [
            {
                Key: 'MODALIDAD',
                Value: oferta.Customer.PartyRole
            },
            {
                Key: 'MON_MAXI',
                Value: oferta.LoanAgreement.LoanProduct.find(f => f.Loan.Limit.Type == 'max').Loan.Limit.Amount
            },
            {
                Key: 'INI_VIGE',
                Value: this.datePipe.transform(oferta.CustomerOffer.ValidityPeriod.FromDateTime, 'dd/MM/yyyy')
            },
            {
                Key: 'FIN_VIGE',
                Value: this.datePipe.transform(oferta.CustomerOffer.ValidityPeriod.ToDateTime, 'dd/MM/yyyy')
            },
            {
                Key: 'TASA_TEA',
                Value: oferta.CustomerOffer.OfferedAgreement.Account.find(f => f.AccountService.AccountAdministrationCharge.RelatedInterest.find(w => w.InterestType == 'TEA')).AccountService.AccountAdministrationCharge.RelatedInterest.find(f => f.InterestType == 'TEA').Rate
            },
            {
                Key: 'TASA_TEM',
                Value: oferta.CustomerOffer.OfferedAgreement.Account.find(f => f.AccountService.AccountAdministrationCharge.RelatedInterest.find(w => w.InterestType == 'TEM')).AccountService.AccountAdministrationCharge.RelatedInterest.find(f => f.InterestType == 'TEM').Rate
            },
            {
                Key: 'TASA_TCA',
                Value: oferta.CustomerOffer.OfferedAgreement.Account.find(f => f.AccountService.AccountAdministrationCharge.RelatedInterest.find(w => w.InterestType == 'TCA')).AccountService.AccountAdministrationCharge.RelatedInterest.find(f => f.InterestType == 'TCA').Rate
            },
            {
                Key: 'TASA_TNA',
                Value: oferta.CustomerOffer.OfferedAgreement.Account.find(f => f.AccountService.AccountAdministrationCharge.RelatedInterest.find(w => w.InterestType == 'TNA')).AccountService.AccountAdministrationCharge.RelatedInterest.find(f => f.InterestType == 'TNA').Rate
            },
            {
                Key: 'PLA_MINI_REP_SEF',
                Value: codeRUO === AppConstants.Products.REPROSEF ? oferta.AditionalInformationList.AditionalInformation.find(f => f.Key === 'NUM_CUOT1').Value : ''
            },
            {
                Key: 'PLA_MAXI_REP_SEF',
                Value: codeRUO === AppConstants.Products.REPROSEF ? oferta.AditionalInformationList.AditionalInformation.find(f => f.Key === 'NUM_CUOT2').Value : ''
            },
            {
                Key: 'PLA_MINI',
                Value: oferta.LoanAgreement.LoanProduct.find(f => f.Loan.Limit.Type == 'min').Loan.WeightedAverageLife
            },
            {
                Key: 'PLA_MAXI',
                Value: oferta.LoanAgreement.LoanProduct.find(f => f.Loan.Limit.Type == 'min').Loan.WeightedAverageLoan
            },
            {
                Key: 'LIN_EFEX_FINA',
                Value: oferta.LoanAgreement.LoanProduct.find(f => f.Loan.Limit.Type == 'newEfexLine').Loan.Limit.Amount
            },
            {
                Key: 'TIP_TARJ',
                Value: oferta.PaymentCard.Type
            },
            {
                Key: 'LIN_TC_FINA',
                Value: oferta.LoanAgreement.LoanProduct.find(f => f.Loan.Limit.Type == 'newTcLine').Loan.Limit.Amount
            },
            {
                Key: 'LIN_INI',
                Value: oferta.LoanAgreement.LoanProduct.find(f => f.Loan.Limit.Type == 'lastLine').Loan.Limit.Amount
            },
            {
                Key: 'LIN_FINA',
                Value: oferta.LoanAgreement.LoanProduct.find(f => f.Loan.Limit.Type == 'newLine').Loan.Limit.Amount
            },
            {
                Key: 'TIP_MONE',
                Value: (oferta.CustomerOffer.OfferedAgreement.Account.find(f => f.AccountService.AccountAdministrationCharge.RelatedInterest.find(w => w.InterestType == 'TEA')).BaseCurrency == '1') ? 'S/' : '$'
            },
            {
                Key: 'COD_TIPO_TARJ',
                Value: this.getValueReferenceParameter(oferta.PaymentCard.ProfileNumber, AppConstants.ParameterCode.SUB_PRODUCTOS_TC) //oferta.PaymentCard.ProfileNumber
            },
            {
                Key: 'MONTO_COCO',
                Value: this.amountcocoValidte
            },
            {
                Key: 'PER_GRAC',
                Value: this.getValueWilcard('PER_GRAC', oferta.AditionalInformationList.AditionalInformation)
            },
            {
                Key: 'CARACTER',
                Value: this.getValueWilcard('CARACTER', oferta.AditionalInformationList.AditionalInformation)
            },
            {
                Key: 'SD_CON_RESCATE',
                Value: this.getValueWilcard('SD_CON_RESCATE', oferta.AditionalInformationList.AditionalInformation)
            },
            {
                Key: 'SD_SIN_RESCATE',
                Value: this.getValueWilcard('SD_SIN_RESCATE', oferta.AditionalInformationList.AditionalInformation)
            },
            {
                Key: 'SEGU_MONTO_MINI',
                Value: this.getValueWilcard('MON_MINI_SEGU', oferta.AditionalInformationList.AditionalInformation)
            },
            {
                Key: 'SEGU_MONTO_MAXI',
                Value: this.getValueWilcard('MON_MAXI_SEGU', oferta.AditionalInformationList.AditionalInformation)
            },
            {
                Key: 'TASA_SEG_TEA',
                Value: this.getValueWilcard('TASA_TEA_SEG', oferta.AditionalInformationList.AditionalInformation)
            },
            {
                Key: 'OBS_DETAIL',
                Value: this.getValueWilcard('OBS_DETAIL', oferta.AditionalInformationList.AditionalInformation)
            },
            {
                Key: 'IND_CLIE',
                Value: this.getValueReferenceParameter(oferta.Customer.CustomerReference, AppConstants.ParameterCode.TIPO_OFERTA_TC)
            },
            {
                Key: 'DIFERIDO',
                Value: this.getValueDiferido(this.getValueWilcard('DIFERIDO', oferta.AditionalInformationList.AditionalInformation))
            },
            {
              Key: 'PRD_NUEVO',
              Value: this.newDesCard
            },
            {
              Key: 'PRD_ACTUAL',
              Value: this.actDesCard
            },
            {
              Key: 'NROTARJ',
              Value: this.actNroCard
            }
        ];

        if (additionalProperties.length > 0) {
            arrayProperties = [...arrayProperties, ...additionalProperties]
        }
        const FORMAT_TASA = ['TASA_TEA', 'TASA_TEM', 'TASA_TCA', 'TASA_TNA', 'TEM_EFEX', 'TEA_EFEX'];

        orderArray.forEach(element => {
            let row = element.tabDetCode006;
            let esNulo = false;
 
            arrayProperties.forEach(p => {
                let property = p;
                if (row.includes(property.Key)) {
                    row = row.replace(property.Key, (property.Key == element.tabDetCode007 || property.Key == "LINEA_EFEX") ? this.formatCurrency(property.Value) : ((FORMAT_TASA.includes(property.Key)) ? this.formatTasas(property.Value) : property.Value));
                    if(property.Value==null) esNulo=true;
                }
            });

            if (!esNulo) array.push(row);
        });

        return array;
    }

    async getProductEFEX(contractNumber: string): Promise<ProductoEFEX> {

        let result = new ProductoEFEX();

        // Api Consulta Informacion Financiera
        let amountEfex = await this.getAmountEfex(contractNumber);
        if (amountEfex == 0 || amountEfex == null) {
            this.validGetDataEfex = false;
            this.alertaService.showMessage(AppConstants.TitleModal.EFEX_ACTIVE_PRODUCT, AppConstants.MessageModal.MESSAGE_ERROR_AMMOUNT_EFEX, MessageSeverity.error);
            return result;
        }

        // Api Consulta Producto Activo
        let product = await this.getActiveProduct(contractNumber);
        if (product.product == null || product.product == "" || product.panNumber == "") {
            this.validGetDataEfex = false;
            this.alertaService.showMessage(AppConstants.TitleModal.EFEX_ACTIVE_PRODUCT, AppConstants.MessageModal.MESSAGE_ERROR_PRODUCT_ACTIVE, MessageSeverity.error);
            return result;
        }

        let model = {
            UserId: this.usersessionId,
            ContractNumber: contractNumber,
            ProductCode: product.product,
            SubProductCode: product.subProduct,
            CardType: product.cardType,
            CardBrand: product.cardBrand,
            NumberOfDues: 1,
            Amount: amountEfex,
        }
        // Api Consulta Tasa Producto
        let productRate = await this.getProductRate(model);
        if (productRate.tem == null || productRate.tem == 0) {
            this.validGetDataEfex = false;
            this.alertaService.showMessage(AppConstants.TitleModal.EFEX_ACTIVE_PRODUCT, AppConstants.MessageModal.MESSAGE_ERROR_PRODUCT_RATE, MessageSeverity.error);
            return result;
        }

        result.amount = amountEfex;
        result.tem = productRate.tem;
        result.tea = productRate.tea;
        result.productCode = product.product;
        result.subProductCode = product.subProduct;
        result.cardType = product.cardType;
        result.settlementGroup = product.settlementGroup;
        result.panNumber = product.panNumber;
        result.maskPan = product.maskPan;
        result.productType = product.productType;
        result.productTypeDescription = product.productTypeDescription;
        result.settlementGroup = product.settlementGroup;
        result.cardBrand = product.cardBrand;
        result.expiryDate = product.expiryDate;

        return result;
    }

    addAditionalInfoEFEX(model: ProductoEFEX) {
        var properties = [
            {
                Key: 'LINEA_EFEX',
                Value: model.amount
            },
            {
                Key: 'TEM_EFEX',
                Value: model.tem
            },
            {
                Key: 'TEA_EFEX',
                Value: model.tea
            },
        ];
        return properties;
    }

    async getAmountEfex(contractNumber: string) {
        let value = 0;
        await this.onboardingIntegrationService.getAmountEfex(contractNumber).toPromise().then((data) => {
            value = data.availableAmount;
        },
            (error: HttpErrorResponse) => {
                value = 0;
            })
        return value;
    }

    async getActiveProduct(contractNumber: string) {
        let model = {
            UserId: this.usersessionId,
            ContractNumber: contractNumber.slice(-12),
        }
        let response = new ActiveProductResponse();
        await this.onboardingIntegrationService.getActiveProduct(model).toPromise().then((data) => {
            response = data;
        },
            (error: HttpErrorResponse) => {
                //return new ProductRateResponse()
            })
        return response;
    }

    async getDataCardAct(){
      let client: DocumentsType = this.documents.find(f => f.code === this.documentTyperForm);
      var model = new RequestGetProducts();
      model.documentType = client.t24;
      model.documentNumber = this.documentNumberForm;
      await this.clientService.getProductsByDocumentCP(model)
          .toPromise().then((data) => {
              this.apellidoPaternoCliente = data.lastName;
              this.apellidoMaternoCliente = data.secondLastName;
              this.nombre1Cliente = data.givenName + ' ' + data.middleName;
              this.FirstNameClient = data.givenName;
              this.SecondNameClient = data.middleName;
              this.clientName = this.apellidoPaternoCliente + ' ' + this.apellidoMaternoCliente + ' ' + this.FirstNameClient;
              var clienName = this.FirstNameClient + ' ' + this.SecondNameClient + ' ' + this.apellidoPaternoCliente + ' ' + this.apellidoMaternoCliente;
              this.person = '<b>' + client.name + ' :</b> ' + this.documentNumberForm + ' - <b>Cliente:</b> ' + clienName;
              this.personResponsive = clienName + '<br><strong>' + client.name + ' :</strong> ' + this.documentNumberForm;
              this.actDesCard = data.cards[0].productName;
              this.actNroCard = data.cards[0].cardNumber;
          },
          (error: HttpErrorResponse) => {
              this.alertaService.showMessage('Cambio Producto :: Error', 'Error al obtener el actual producto.',MessageSeverity.error);
              this.loading = false;
          });
    }


    async getProductRate(model: any) {
        let response = new ProductRateResponse();
        await this.onboardingIntegrationService.getProductRate(model).toPromise().then((data) => {
            response = data;
        },
            (error: HttpErrorResponse) => {
                //return new ProductRateResponse()
            })
        return response;
    }

    formatTasas(input: string) {
        let result = (input == null || input == undefined || input == 'undefined') ? '' : Number(input).toFixed(2);
        return result;
    }

    formatCurrency(input: string) {
        let result = (input == null || input == undefined || input == 'undefined') ? '0' : Number(input).toFixed(2);
        return result.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    async contractInformation(contractNumber: string){

      let objeto = {
        ShoppingLine : '0',
        CashLine: '0'
      }

      try {
        const data = await this.clientService.getDetailTCByNumber({
          contractNumber: contractNumber.slice(-12),
          ignoreMovements: true
        } as RequestGetCardDetail).toPromise();

        objeto.ShoppingLine = data.shoppingLine;
        objeto.CashLine = data.cashLine;

      } catch (error) {
        if (error instanceof HttpErrorResponse) {
          console.error("Error al obtener el detalle:", error);
          this.alertaService.showMessage('Error', 'Error al obtener el detalle de la linea.', MessageSeverity.error);
        }
      }

      return objeto;

    }

    obtenerIntentosToken(posicion: string) {
        var intentosToken = 0;
        var oferta = this.offers.RetrieveCustomerOfferProcedureResponse.Offers[posicion] as Offers;
        var codigoProducto = oferta.CustomerOffer.OfferedAgreement.Product.ProductIdentification.Identifier;
        var codBase = oferta.Customer.PartyRole;
        var productos = this.products.filter(x => x.tabDetCode001 == codigoProducto);

        var comodines = oferta.AditionalInformationList.AditionalInformation;
        var reengancheCDD: string = '0';

        Object.keys(comodines).forEach(key => {
            if (comodines[key]['Key'] == 'IND_CONV_PEF') {
                reengancheCDD = comodines[key]['Value'];
            }
        });

        let arrayCoincidencias: Array<any> = new Array<any>();

        if (productos.length > 1) {
            if (codBase != undefined && codBase != undefined && codBase != '') {
                if (codigoProducto === AppConstants.Products.REPROSEF) {
                    let baseOrigenItem = oferta.AditionalInformationList.AditionalInformation.find(f => f.Key === 'BASE_ORIGEN');
                    let baseOrigen = baseOrigenItem ? baseOrigenItem.Value : null;
                    baseOrigen = baseOrigen ? baseOrigen : 'NORMAL';

                    productos.filter((value, index: number, array: []) => {
                        value.tabDetCode007 = value.tabDetCode007 ? value.tabDetCode007 : 'NORMAL';
                        if (codBase.includes(value.tabDetCode006) &&
                            value.tabDetCode007.toUpperCase() === baseOrigen.toUpperCase()) {
                            arrayCoincidencias.push({
                                coincidencias: 5,
                                indice: index
                            });
                        }
                    });
                } else {
                    for (let index = 0; index < productos.length; index++) {
                        var item = {
                            coincidencias: this.validarCoincidencias(codBase, productos[index], reengancheCDD),
                            indice: index
                        };

                        arrayCoincidencias.push(item);
                    }
                }
            }

            if (codigoProducto == AppConstants.Products.REENGANCHECDD) {
                for (let index = 0; index < productos.length; index++) {
                    arrayCoincidencias.push({ coincidencias: this.validarCoincidencias('', productos[index], reengancheCDD), indice: index });
                }
            }

            var producto = arrayCoincidencias.filter(x => Math.max(x.coincidencias))[0];

            if (producto == undefined) {
                intentosToken = this.validateIntentosToken(productos[productos.length - 1].tabDetCode011);
            } else {
                intentosToken = this.validateIntentosToken(productos[producto.indice].tabDetCode011);
            }

        } else if (productos.length == 1) {
            intentosToken = this.validateIntentosToken(productos[0].tabDetCode011);
        }

        return intentosToken;
    }

    validateIntentosToken(value: string) {
        return value == null || value == '' || value == undefined ? 3 : parseInt(value);
    }

    obtenerNombreProducto(posicion: string) {
        var nombreOferta = '';
        var oferta = this.offers.RetrieveCustomerOfferProcedureResponse.Offers[posicion] as Offers;
        var codigoProducto = oferta.CustomerOffer.OfferedAgreement.Product.ProductIdentification.Identifier;
        var codBase = oferta.Customer.PartyRole;
        var productos = this.products.filter(x => x.tabDetCode001 == codigoProducto);

        var comodines = oferta.AditionalInformationList.AditionalInformation;
        var reenganche: string = '0';

        Object.keys(comodines).forEach(key => {
            if (comodines[key]['Key'] == 'IND_CONV_PEF') {
                reenganche = comodines[key]['Value'];
            }
            if (comodines[key]['Key'] == 'IND_ORIG_SEF') {
                reenganche = comodines[key]['Value'];
            }
        });

        let arrayCoincidencias: Array<any> = new Array<any>();

        if (productos.length > 1) {
            if (codBase != undefined && codBase != '') {
                if (codigoProducto === AppConstants.Products.REPROSEF) {
                    let baseOrigenItem = oferta.AditionalInformationList.AditionalInformation.find(f => f.Key === 'BASE_ORIGEN');
                    let baseOrigen = baseOrigenItem ? baseOrigenItem.Value : null;
                    baseOrigen = baseOrigen ? baseOrigen : 'NORMAL';

                    productos.filter((value, index: number, array: []) => {
                        value.tabDetCode007 = value.tabDetCode007 ? value.tabDetCode007 : 'NORMAL';
                        if (codBase.includes(value.tabDetCode006) &&
                            value.tabDetCode007.toUpperCase() === baseOrigen.toUpperCase()) {
                            arrayCoincidencias.push({
                                coincidencias: 5,
                                indice: index
                            });
                        }
                    });
                } else {
                    for (let index = 0; index < productos.length; index++) {
                        var item = {
                            coincidencias: this.validarCoincidencias(codBase, productos[index], reenganche),
                            indice: index
                        };

                        arrayCoincidencias.push(item);
                    }
                }
            }

            if (codigoProducto == AppConstants.Products.REENGANCHECDD) {
                for (let index = 0; index < productos.length; index++) {
                    arrayCoincidencias.push({ coincidencias: this.validarCoincidencias('', productos[index], reenganche), indice: index });
                }
            }

            if (codigoProducto == AppConstants.Products.REENGANCHESEF) {
                for (let index = 0; index < productos.length; index++) {
                    arrayCoincidencias.push({ coincidencias: this.validarCoincidencias('', productos[index], reenganche), indice: index });
                }
            }

            var producto = arrayCoincidencias.filter(x => Math.max(x.coincidencias))[0];

            if (producto == undefined) {
                nombreOferta = productos[productos.length - 1].tabDetCode009;
            } else {
                nombreOferta = productos[producto.indice].tabDetCode009;
            }

        } else if (productos.length == 1) {
            nombreOferta = productos[0].tabDetCode009;
        }

        return nombreOferta;
    }

    validarCoincidencias(codeBase: string, producto: any, indicadorPef: string) {
        let coincidencias: number = 0;
        if (producto.tabDetCode006 != undefined &&
            producto.tabDetCode006 != null &&
            producto.tabDetCode006 != '' &&
            codeBase.includes(producto.tabDetCode006)) {
            coincidencias++;
        }

        if (producto.tabDetCode007 != undefined &&
            producto.tabDetCode007 != null &&
            producto.tabDetCode007 != '' &&
            codeBase.includes(producto.tabDetCode007)) {
            coincidencias++;
        }

        if (producto.tabDetCode010 != undefined &&
            producto.tabDetCode010 != null &&
            producto.tabDetCode010 != '' &&
            producto.tabDetCode001 == AppConstants.Products.REENGANCHECDD &&
            indicadorPef == producto.tabDetCode010) {
            coincidencias++;
        }
        if (producto.tabDetCode001 == AppConstants.Products.REENGANCHESEF &&
            indicadorPef == producto.tabDetCode006) {
            coincidencias++;
        }

        return coincidencias;
    }

    async validarPolitica(moneda: string) {
        this.loading = true;
        this.ofertaActive = false;
        try {
            this.infoBloqueo = '';

            let response = this.clientService.validarPoliticarCorporativas(this.documentTyperForm,
                this.documentNumberForm,
                this.clientName,
                moneda == AppConstants.TipoMonedaId.SOLES.toString() ? AppConstants.TipoMonedaISO.SOLES : AppConstants.TipoMonedaISO.DOLARES)
                .toPromise();

            if (response != undefined) {
                response.then(async s => {
                    this.politicaCode = s.estadoDescripcion;
                    this.politicaCodeResponse = s.codigo;

                    switch (s.codigo) {

                        case '000': {
                            this.infopolitica = '';
                            this.ofertaActive = true;
                            //this.btnEscoger = false;
                            break;
                        }
                        case '002': {
                            this.infopolitica = '' + s.codigo + ' - ' + s.mensaje;
                            this.ofertaActive = false;
                            break;

                        }
                        case '003': {
                            this.infopolitica = '' + s.codigo + ' - ' + s.mensaje;
                            this.ofertaActive = true;
                            //this.btnEscoger = true;
                            break;
                        }
                        case '004': {
                            this.infopolitica = '' + s.codigo + ' - ' + s.mensaje;
                            this.ofertaActive = true;
                            //this.btnEscoger = true;
                            break;
                        }
                        default: {
                            this.infopolitica = '' + s.codigo + ' - ' + s.mensaje;
                            this.ofertaActive = true;
                            //this.btnEscoger = false;
                            break;
                        }
                    }

                    for (let k in this.offers.RetrieveCustomerOfferProcedureResponse.Offers) {

                        if (this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].Show === "NO") {
                            continue;
                        }

                        var codigoproducto = this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].CustomerOffer.OfferedAgreement.Product.ProductIdentification.Identifier;
                        var idproducto = this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].CustomerOffer.CustomerOfferReference;
                        var comodines = this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].AditionalInformationList.AditionalInformation;
                        var modoactivacion: string = '';
                        var reengancheCDD: string = '0';
                        var reprotcPeriodoGracia: string = '';
                        var character: string = '';
                        var sdConRescate: string;
                        var sdSinRescate: string;
                        var offerAmountMaxSure: string;
                        var offerTEASure: string;

                        Object.keys(comodines).forEach(key => {
                            if (comodines[key]['Key'] == 'MOD_ACTI_ONBO') {
                                modoactivacion = comodines[key]['Value'];
                            }
                            if (comodines[key]['Key'] == 'IND_CONV_PEF') {
                                reengancheCDD = comodines[key]['Value'];
                            }
                            if (comodines[key]['Key'] == 'PER_GRAC') {
                                reprotcPeriodoGracia = comodines[key]['Value'];
                            }
                            if (comodines[key]['Key'] == 'CARACTER') {
                                character = comodines[key]['Value'];
                            }
                            if (comodines[key]['Key'] == 'SD_CON_RESCATE') {
                                sdConRescate = comodines[key]['Value'];
                            }
                            if (comodines[key]['Key'] == 'SD_SIN_RESCATE') {
                                sdSinRescate = comodines[key]['Value'];
                            }
                            if (comodines[key]['Key'] == 'MON_MAXI_SEGU') {
                                offerAmountMaxSure = comodines[key]['Value'];
                            }
                            if (comodines[key]['Key'] == 'TASA_TEA_SEG') {
                                offerTEASure = comodines[key]['Value'];
                            }
                        });

                        let nombreImagen = '';

                        if (codigoproducto == AppConstants.Products.CDD) {
                            nombreImagen = this.obtenerNombreImagen('%');
                        } else if (codigoproducto == AppConstants.Products.CAPTACION) {
                            this.nameProductCappta = this.obtenerNombreProducto(k);
                        } else if (codigoproducto == AppConstants.Products.CAMBPROD) {
                          nombreImagen = 'cp.png';
                        } else {
                            nombreImagen = this.obtenerNombreImagen(modoactivacion);
                        }

                        nombreImagen = nombreImagen == '' ? 'e.png' : nombreImagen;

                        let additionalProperties: { Key: string, Value: number }[];
                        additionalProperties = [];
                        let productoEfex = new ProductoEFEX();
                        if (codigoproducto == AppConstants.Products.EFEX) {
                            productoEfex = await this.getProductEFEX(this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].Customer.Agreement.Account.Identification.BBAN);
                            let infoEfex = this.addAditionalInfoEFEX(productoEfex);
                            additionalProperties = additionalProperties.concat(infoEfex);
                            let diferido = this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].AditionalInformationList.AditionalInformation.find(f => f.Key === 'DIFERIDO');
                            if (diferido == null || diferido == undefined) {
                                this.validGetDataEfex = false;
                                this.alertaService.showMessage(AppConstants.TitleModal.EFEX_ACTIVE_PRODUCT, AppConstants.MessageModal.MESSAGE_ERROR_DIFERIDO, MessageSeverity.error);
                            } else {
                                productoEfex.diferido = this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].AditionalInformationList.AditionalInformation.find(f => f.Key === 'DIFERIDO').Value;
                            }
                        }

                        if (codigoproducto == AppConstants.Products.CAMBPROD){
                          await this.getDataCardAct();
                        }

                        let json = {
                            title: codigoproducto == AppConstants.Products.CAPTACION ? 'TARJETA RIPLEY' : this.obtenerNombreProducto(k),
                            codigoproducto: codigoproducto,
                            idproducto: idproducto,
                            modoactivacion: modoactivacion,
                            indicadorOrigenSef: null,
                            saldo: this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].LoanAgreement.LoanProduct.find(f => f.Loan.Limit.Type == 'max').Loan.Limit.Amount.toFixed(2),
                            offerMontMin: this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].LoanAgreement.LoanProduct.find(f => f.Loan.Limit.Type == 'min').Loan.Limit.Amount,
                            offerMontMax: this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].LoanAgreement.LoanProduct.find(f => f.Loan.Limit.Type == 'max').Loan.Limit.Amount,
                            offerPlazoMin: null,
                            offerPlazoMax: null,
                            offerNumDiaAtra: null,
                            codprodBase: this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].Customer.PartyRole,
                            saldoformateado: codigoproducto == AppConstants.Products.CAPTACION ? this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].LoanAgreement.LoanProduct.find(f => f.Loan.Limit.Type == 'newTcLine').Loan.Limit.Amount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].LoanAgreement.LoanProduct.find(f => f.Loan.Limit.Type == 'max').Loan.Limit.Amount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                            fechaInicio: this.datePipe.transform(this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].CustomerOffer.ValidityPeriod.FromDateTime, 'dd/MM/yyyy'),
                            fechaFin: this.datePipe.transform(this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].CustomerOffer.ValidityPeriod.ToDateTime, 'dd/MM/yyyy'),
                            imagenproducto: codigoproducto == AppConstants.Products.CAPTACION ? this.imageBase + 'icon_m_capta.png' : this.imageBase + 'icon_' + nombreImagen,
                            imagenproducto_m: codigoproducto == AppConstants.Products.CAPTACION ? this.imageBase + 'icon_m_capta.png' : this.imageBase + 'icon_m_' + nombreImagen,
                            tem: this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].CustomerOffer.OfferedAgreement.Account.find(f => f.AccountService.AccountAdministrationCharge.RelatedInterest.find(w => w.InterestType == 'TEM')).AccountService.AccountAdministrationCharge.RelatedInterest.find(f => f.InterestType == 'TEM').Rate + '%',
                            temValue: this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].CustomerOffer.OfferedAgreement.Account.find(f => f.AccountService.AccountAdministrationCharge.RelatedInterest.find(w => w.InterestType == 'TEM')).AccountService.AccountAdministrationCharge.RelatedInterest.find(f => f.InterestType == 'TEM').Rate,
                            tca: this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].CustomerOffer.OfferedAgreement.Account.find(f => f.AccountService.AccountAdministrationCharge.RelatedInterest.find(w => w.InterestType == 'TCA')).AccountService.AccountAdministrationCharge.RelatedInterest.find(f => f.InterestType == 'TCA').Rate + '%',
                            tna: this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].CustomerOffer.OfferedAgreement.Account.find(f => f.AccountService.AccountAdministrationCharge.RelatedInterest.find(w => w.InterestType == 'TEA')).AccountService.AccountAdministrationCharge.RelatedInterest.find(f => f.InterestType == 'TNA').Rate + '%',
                            tnaValue: this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].CustomerOffer.OfferedAgreement.Account.find(f => f.AccountService.AccountAdministrationCharge.RelatedInterest.find(w => w.InterestType == 'TEA')).AccountService.AccountAdministrationCharge.RelatedInterest.find(f => f.InterestType == 'TNA').Rate,
                            teaValue: this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].CustomerOffer.OfferedAgreement.Account.find(f => f.AccountService.AccountAdministrationCharge.RelatedInterest.find(w => w.InterestType == 'TEA')).AccountService.AccountAdministrationCharge.RelatedInterest.find(f => f.InterestType == 'TEA').Rate,
                            tea: this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].CustomerOffer.OfferedAgreement.Account.find(f => f.AccountService.AccountAdministrationCharge.RelatedInterest.find(w => w.InterestType == 'TEA')).AccountService.AccountAdministrationCharge.RelatedInterest.find(f => f.InterestType == 'TEA').Rate == '' ||
                                this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].CustomerOffer.OfferedAgreement.Account.find(f => f.AccountService.AccountAdministrationCharge.RelatedInterest.find(w => w.InterestType == 'TEA')).AccountService.AccountAdministrationCharge.RelatedInterest.find(f => f.InterestType == 'TEA').Rate == undefined ||
                                this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].CustomerOffer.OfferedAgreement.Account.find(f => f.AccountService.AccountAdministrationCharge.RelatedInterest.find(w => w.InterestType == 'TEA')).AccountService.AccountAdministrationCharge.RelatedInterest.find(f => f.InterestType == 'TEA').Rate == null ? '' : Number(this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].CustomerOffer.OfferedAgreement.Account.find(f => f.AccountService.AccountAdministrationCharge.RelatedInterest.find(w => w.InterestType == 'TEA')).AccountService.AccountAdministrationCharge.RelatedInterest.find(f => f.InterestType == 'TEA').Rate).toFixed(2) + '%',
                            tipoMoneda: this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].CustomerOffer.OfferedAgreement.Account.find(f => f.AccountService.AccountAdministrationCharge.RelatedInterest.find(w => w.InterestType == 'TEA')).BaseCurrency || '1',
                            tipoMonedaSimbolo: (this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].CustomerOffer.OfferedAgreement.Account.find(f => f.AccountService.AccountAdministrationCharge.RelatedInterest.find(w => w.InterestType == 'TEA')).BaseCurrency == '1') ? 'S/' : '$',
                            isCappta: codigoproducto != AppConstants.Products.CAPTACION ? true : false,
                            reeganchevalidateCdd: reengancheCDD,
                            modoactivacionPYA: this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].CustomerOffer.Audit.GuidelineComplianceCheck.CheckedGuideline.find(f => f.Description == 'pyActivationMod').Type,
                            TASA_TEA: this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].CustomerOffer.OfferedAgreement.Account.find(f => f.AccountService.AccountAdministrationCharge.RelatedInterest.find(w => w.InterestType == 'TEA')).AccountService.AccountAdministrationCharge.RelatedInterest.find(f => f.InterestType == 'TEA').Rate,
                            TASA_TEM: this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].CustomerOffer.OfferedAgreement.Account.find(f => f.AccountService.AccountAdministrationCharge.RelatedInterest.find(w => w.InterestType == 'TEM')).AccountService.AccountAdministrationCharge.RelatedInterest.find(f => f.InterestType == 'TEM').Rate,
                            TASA_TCA: this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].CustomerOffer.OfferedAgreement.Account.find(f => f.AccountService.AccountAdministrationCharge.RelatedInterest.find(w => w.InterestType == 'TCA')).AccountService.AccountAdministrationCharge.RelatedInterest.find(f => f.InterestType == 'TCA').Rate,
                            TASA_TNA: this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].CustomerOffer.OfferedAgreement.Account.find(f => f.AccountService.AccountAdministrationCharge.RelatedInterest.find(w => w.InterestType == 'TNA')).AccountService.AccountAdministrationCharge.RelatedInterest.find(f => f.InterestType == 'TNA').Rate,
                            LIN_EFEX_FINA: this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].LoanAgreement.LoanProduct.find(f => f.Loan.Limit.Type == 'newEfexLine').Loan.Limit.Amount,
                            COD_TIPO_TARJ: this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].PaymentCard.ProfileNumber,
                            TIP_TARJ: this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].PaymentCard.Type,
                            LIN_TC_FINA: this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].LoanAgreement.LoanProduct.find(f => f.Loan.Limit.Type == 'newTcLine').Loan.Limit.Amount,
                            LIN_FINA: this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].LoanAgreement.LoanProduct.find(f => f.Loan.Limit.Type == 'newLine').Loan.Limit.Amount,

                            LIN_ACTUAL: this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].LoanAgreement.LoanProduct.find(f => f.Loan.Limit.Type == 'lastLine').Loan.Limit.Amount,
                            LIN_EFEX_ACTUAL: this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].LoanAgreement.LoanProduct.find(f => f.Loan.Limit.Type == 'lastEfexLine').Loan.Limit.Amount,

                            NUM_CUEN: this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].Customer.Agreement.Account.Identification.BBAN,
                            CLASE: this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].Customer.ContactPersonRole.Person.CreditRating,
                            BASE_ORIGEN: '',
                            PER_GRAC: reprotcPeriodoGracia,
                            CARACTER: character,
                            showOfferProperties: this.getPropertiesOffer(codigoproducto, k, additionalProperties),
                            fechaPago: null,
                            intentosToken: this.obtenerIntentosToken(k),
                            block: false,
                            messageBlock: '',
                            messageSefRsat: '',
                            diasMora: null,
                            sdConRescate: sdConRescate,
                            sdSinRescate: sdSinRescate,
                            modoactivacionTC: this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].CustomerOffer.Audit.GuidelineComplianceCheck.CheckedGuideline.find(f => f.Description == 'tcAtivationMod').Type,
                            offerAmountMaxSure: offerAmountMaxSure,
                            offerTEASure: offerTEASure,
                            typeOfferTC: this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].Customer.CustomerReference,
                            offersearchdate: this.offersearchdate,
                            IND_CLIE: this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].Customer.CustomerReference,
                            productoEfex: productoEfex,
                            LINEA_ACTUAL: '',
                            LINEA_NUEVA: '',
                        };

                        if (codigoproducto == AppConstants.Products.IL) {
                          const contractInfo = await this.contractInformation(this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].Customer.Agreement.Account.Identification.BBAN);
                          json.LINEA_ACTUAL = contractInfo.ShoppingLine,
                          json.LINEA_NUEVA = contractInfo.CashLine
                        }

                        if (codigoproducto == AppConstants.Products.REPROSEF) {
                            json.offerPlazoMin = this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].AditionalInformationList.AditionalInformation.find(f => f.Key === 'NUM_CUOT1').Value;
                            json.offerPlazoMax = this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].AditionalInformationList.AditionalInformation.find(f => f.Key === 'NUM_CUOT2').Value;

                            const baseOrigenItem = this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].AditionalInformationList.AditionalInformation.find(f => f.Key === 'BASE_ORIGEN');
                            if (baseOrigenItem) {
                                json.BASE_ORIGEN = baseOrigenItem.Value;
                            }

                            const item = this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].AditionalInformationList.AditionalInformation.find(f => f.Key === 'NUM_DIAS_ATRA');
                            if (item) {
                                json.offerNumDiaAtra = item.Value;
                            }

                            const fechaPago = this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].AditionalInformationList.AditionalInformation.find(f => f.Key === 'FEC_PAGO');
                            if (fechaPago) {
                                json.fechaPago = fechaPago.Value;
                            }
                        } else {
                            json.offerPlazoMin = this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].LoanAgreement.LoanProduct.find(f => f.Loan.Limit.Type == 'min').Loan.WeightedAverageLife;
                            json.offerPlazoMax = this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].LoanAgreement.LoanProduct.find(f => f.Loan.Limit.Type == 'min').Loan.WeightedAverageLoan;
                        }

                        if (codigoproducto == AppConstants.Products.REENGANCHESEF) {
                            const indicadorOrigenSef = this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].AditionalInformationList.AditionalInformation.find(f => f.Key === 'IND_ORIG_SEF');
                            if (indicadorOrigenSef) {
                                json.indicadorOrigenSef = indicadorOrigenSef.Value;
                            }
                            const fechaPago = this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].AditionalInformationList.AditionalInformation.find(f => f.Key === 'FEC_PAGO');
                            if (fechaPago) {
                                json.fechaPago = fechaPago.Value;
                            }
                        }

                        if (codigoproducto == AppConstants.Products.SEFPLUS) {
                            const fechaPago = this.offers.RetrieveCustomerOfferProcedureResponse.Offers[k].AditionalInformationList.AditionalInformation.find(f => f.Key === 'FEC_PAGO');
                            if (fechaPago) {
                                json.fechaPago = fechaPago.Value;
                            }
                        }

                        if (codigoproducto == AppConstants.Products.REPROTC) {
                            json.BASE_ORIGEN = json.codprodBase;
                        }

                        if (codigoproducto == AppConstants.Products.CAMBPROD){
                          json.block = true;
                        }

                        if (this.politicaCodeResponse == '001' ||
                            this.politicaCodeResponse == '002' ||
                            this.politicaCodeResponse == '003' ||
                            this.politicaCodeResponse == '004') {

                            if (codigoproducto == AppConstants.Products.REENGANCHESEF &&
                                (this.politicaCodeResponse == '002' || this.politicaCodeResponse == '003')) {
                                this.slides.push(json);
                                this.ofertaActive = false;
                            } else {
                                this.slides.push(json);
                                // if (codigoproducto == AppConstants.Products.REPROTC ||
                                //     codigoproducto == AppConstants.Products.REPROSEF) {
                                //     this.slides.push(json);
                                //     this.infopolitica = '';
                                //     this.ofertaActive = true;
                                // } else {
                                //     this.slides.push(json);
                                //     //this.ofertaActive = true;
                                // }
                            }
                        } else {
                            this.slides.push(json);
                        }

                        if (this.ofertaActive) {
                            await this.clientService.validarPoliticarAndBlocks({
                                contractNumber: json.NUM_CUEN,
                                tipo: (json.BASE_ORIGEN || '').includes('ALIVIO') ? 'ALIVIO' : '',
                                productCode: json.codigoproducto,
                                documentNumber: this.documentNumberForm,
                                documentType: '1'
                            }).toPromise().then((result) => {
                                json.block = result.block;
                                json.messageBlock = result.mensaje;
                                json.diasMora = result.diasAtraso;
                                if (json.messageBlock && !this.infoBloqueo) {
                                    this.infoBloqueo = json.messageBlock;
                                }
                            }, (error: HttpErrorResponse) => {
                                this.alertaService.showMessage('Error', error.error.messages, MessageSeverity.error);
                                this.loading = false;
                            });
                            //console.log('producto efex', productoEfex);
                            if (!json.block && codigoproducto == AppConstants.Products.EFEX) {
                                if (productoEfex.amount <= 0)
                                    json.block = true;
                            }

                            if (!json.block && codigoproducto == AppConstants.Products.REPROTC && (json.BASE_ORIGEN || '').includes('ALIVIO')) {
                                json.diasMora = await this.getDiasMora(json.NUM_CUEN);
                            }

                            if ((!json.block &&
                                codigoproducto == AppConstants.Products.REENGANCHESEF &&
                                json.indicadorOrigenSef == '1') || (!json.block && codigoproducto == AppConstants.Products.SEFPLUS)) {
                                await this.clientService.validationReengancheSefRsat({
                                    contractNumber: json.NUM_CUEN,
                                    offertAmount: json.offerMontMax,
                                    userId: this.usersessionId,
                                    productCode: json.codigoproducto
                                }).toPromise().then((result) => {
                                    json.block = result.showAlert;
                                    json.messageSefRsat = result.message;
                                    if (json.messageSefRsat && !this.infoSefRsat) {
                                        this.infoSefRsat = json.messageSefRsat;
                                    }
                                }, (error: HttpErrorResponse) => {
                                    this.alertaService.showMessage('Error', error.error.messages, MessageSeverity.error);
                                    this.loading = false;
                                });
                            }
                            if (!this.validGetDataEfex) {
                                json.block = true;
                                this.validGetDataEfex = true;
                            }

                            if (codigoproducto == AppConstants.Products.CAMBPROD){
                              if (this.newDesCard == '' || this.newDesCard == null ||
                                  this.actDesCard == '' || this.actDesCard == null ||
                                  this.valCamProd == '' || this.valCamProd == null
                              ){
                                  json.block = true;
                              }
                            }
                        }
                    }

                    var arrayValidate = this.offers.RetrieveCustomerOfferProcedureResponse.Offers;
                    arrayValidate = arrayValidate.filter((r) => !this.productosHiddenPolitica.includes(r.CustomerOffer.OfferedAgreement.Product.ProductIdentification.Identifier));

                    if (arrayValidate.length == 0) {
                        this.infopolitica = '';
                    }

					


                    //this.ofertaActive = true;
                    this.loading = false;
                });
                response.catch(error => {
                    this.alertaService.showMessage(AppConstants.TitleModal.SERVICE_BRMS, error.error.messages, MessageSeverity.error);
                    this.loading = false;
                });
            }
        } catch (err) {
            this.loading = false;
        }
    }

    Clear() {
        this.slides = [];
        let sliderConfig = {
            'slidesToShow': 3,
            'slidesToScroll': 1,
            'dots': false,
            'infinite': false
        };
        if (this.slickModal != undefined) {
            this.slickModal.slides = [];
            this.slickModal.config = sliderConfig;
        }
        this.info = '';
        this.person = '';
    }

    ChangedDocumentType(event) {
        let document = this.documents.find(f => f.code === event.target.value);
        this.maxlength = Number((document.length != null) ? document.length : 0);
        this.LimpiarDNI();
    }

    onEnterKeyDown(event) {
        event.preventDefault();
    }

    verificarSolicitudInProgrres(model: RequestReturnSolicitud) {
        this.loading = true;
        this.solicitudService.returnSolicitud(model).subscribe((response) => {
            if (response.status === 204) {
                this.callGetOffers(model.documentType, model.documentNumber);
            } else {
                if (response.body.userCreation === this.usersessionId) {
                    this.procesarRedireccionamiento(response);
                } else {
                    if (response.body.producto.codigo === AppConstants.Products.EFEX && this.userRolId === AppConstants.RolesCode.CAJERO) {
                        if(response.body.estado == AppConstants.SolicitudState.PENDIENTE_VALIDACION_PINPAD){
                            this.procesarRedireccionamiento(response);
                            return;
                        }
                    }
                    this.loading = false;
                    this.alertaService.showMessage('Error', 'La solicitud ya esta siendo tomada por el usuario ' + response.body.userCreation, MessageSeverity.error);
                }
            }
        },
            (error: HttpErrorResponse) => {
                this.alertaService.showMessage('Error', error.error.messages, MessageSeverity.error);
                this.loading = false;
            });
    }

    validateNavigateWithDataClient() {
        let docType = this.route.snapshot.paramMap.get('docType');
        let docNumber = this.route.snapshot.paramMap.get('docNumber');
        if (docType != null && docNumber != null) {
            this.documentNumberForm = docNumber;
            this.documentTyperForm = docType;
            this.searchOffer();
        }
    }

    async obtenerVariablesControl() {
        this.loading = true;
        await this.parameterService.getParameters(AppConstants.ParameterCode.VARIABLE_CONTROL_HEADER).toPromise().then((response) => {
            this.variablesControl = response;
            this.loading = false;
        });
    }

    obtenerNombreImagen(modoActivacion: string) {
        let nombreImagen = '';
        let variableControl = this.variablesControl.filter(x => x.tabDetCode006 == modoActivacion)[0];

        if (variableControl != undefined && variableControl != null) {
            nombreImagen = variableControl.tabDetCode007;
        }

        return nombreImagen;
    }

    ClearFormProspect() {
        this.formService.resetForm(this.prospectForm);
    }

    async obtenerModosActivacion() {
        await this.parameterService.getParameters(AppConstants.ParameterCode.MODO_ACTIVACION).subscribe((response) => {
            this.modalidadActivacion = response;
        });
    }

    async continueSimulator(row) {
        var cliente = new Cliente();
        cliente.Nombres = this.nombre1Cliente;
        cliente.ApellidoPaterno = this.apellidoPaternoCliente;
        cliente.ApellidoMaterno = this.apellidoMaternoCliente;
        cliente.NumeroDocumento = this.numerodocumento;
        cliente.TipoDocumento = this.documentTyperForm;
        cliente.TipoDocumentoString = this.documentTyperStringForm;
        cliente.CodigoPolica = this.politicaCode;
        cliente.Nombres = this.FirstNameClient;
        cliente.MiddleName = this.SecondNameClient;
        cliente.userCreation = this.usersessionId;
        cliente.offersearchdate = this.offersearchdate;

        var producto = new Producto();
        producto.Nombre = (row.title + ' ' + row.modoactivacion).trim();
        producto.Activacion = row.modoactivacion;
        producto.Imagen = row.imagenproducto;
        producto.Imagen_m = row.imagenproducto_m;
        producto.Codigo = row.codigoproducto;
        producto.Saldo = row.saldo;
        producto.FechaInicio = row.fechaInicio;
        producto.FechaFin = row.fechaFin;
        producto.Tem = row.tem;
        producto.TemValue = row.temValue;
        producto.Tea = row.tea;
        producto.TeaValue = row.teaValue;
        producto.Tna = row.tna;
        producto.TnaValue = row.tnaValue;
        producto.Tca = row.tca;
        producto.IdProducto = row.idproducto;
        producto.TipoMoneda = row.tipoMoneda;
        producto.MontoMinimo = row.offerMontMin;
        producto.MontoMaximo = row.offerMontMax;
        producto.PlazoMinimo = row.offerPlazoMin;
        producto.PlazoMaximo = row.offerPlazoMax;
        producto.NumeroDiasAtraso = row.offerNumDiaAtra;
        producto.diasMora = row.diasMora;
        producto.CodigoBase = row.codprodBase;
        producto.ValidactionCDD = row.reeganchevalidateCdd;
        producto.ModoActivacionPYA = row.modoactivacionPYA;
        producto.TASA_TEA = row.TASA_TEA;
        producto.TASA_TEM = row.TASA_TEM;
        producto.TASA_TCA = row.TASA_TCA;
        producto.TASA_TNA = row.TASA_TNA;
        producto.LIN_EFEX_FINA = row.LIN_EFEX_FINA;
        producto.COD_TIPO_TARJ = row.COD_TIPO_TARJ;
        producto.TIP_TARJ = row.TIP_TARJ;
        producto.LIN_TC_FINA = row.LIN_TC_FINA;
        producto.LIN_FINA = row.LIN_FINA;
        producto.NUM_CUEN = row.NUM_CUEN;
        producto.CLASE = row.CLASE;
        producto.CARACTER = row.CARACTER;
        producto.PER_GRAC = row.PER_GRAC;
        producto.BASE_ORIGEN = row.BASE_ORIGEN;
        producto.FechaPago = row.fechaPago;
        producto.IntentosToken = row.intentosToken;
        producto.indicadorOrigenSef = row.indicadorOrigenSef;
        producto.sdConRescate = row.sdConRescate;
        producto.sdSinRescate = row.sdSinRescate;
        producto.offerAmountMaxSure = row.offerAmountMaxSure;
        producto.offerTEASure = row.offerTEASure;
        producto.productoEfex = row.productoEfex;

        console.log('producto bandeja', producto);

        sessionStorage.setItem(AppConstants.ObjectCliente.CLIENTE, JSON.stringify(cliente));
        sessionStorage.setItem(AppConstants.ObjectCliente.PRODUCTO, JSON.stringify(producto));

        var accessToken = sessionStorage.getItem(AppConstants.Session.ACCESS_TOKEN);

        if (producto.Codigo == AppConstants.Products.CAPTACION ||
            producto.Codigo == AppConstants.Products.IL ||
            producto.Codigo == AppConstants.Products.CAMBPROD) {

            if (!this.platform.is('cordova')) {

                var model = new CreateClientCappta();
                model.clientApePat = this.apellidoPaternoCliente;
                model.clientApeMat = this.apellidoMaternoCliente;
                model.clientNombres = this.nombre1Cliente;
                model.clieMiddleName = this.SecondNameClient;
                model.clientDocumemtType = this.documentTyperForm;
                model.clientDocumemtNumber = this.numerodocumento;
                model.clieMail = this.emailCliente;
                model.clientFechaNac = this.fecNacCliente;
                model.situacion = this.politicaCode;
                model.solCountry = AppConstants.SolicitudParameter.SOL_PAIS;
                model.solCurrency = row.tipoMoneda;
                model.solEnterprise = AppConstants.SolicitudParameter.SOL_EMP;
                model.offerCodProd = row.codigoproducto;
                model.offerId = row.idproducto;
                model.offerModAct = row.modoactivacion;
                model.offerValidityStart = row.fechaInicio;
                model.offerValidityEnd = row.fechaFin;
                model.offerAmountMin = row.offerMontMin;
                model.offerAmountMax = row.offerMontMax;
                model.ProcessId = AppConstants.Process.ONBOARDING;
                model.TaskId = AppConstants.WFTareas.EVA_PRODUCT;
                model.Channel = !this.platform.is('cordova') ? AppConstants.Channel.WEB : AppConstants.Channel.MOVIL;
                model.offeCodigoBase = row.codprodBase;

                model.OfeLinEfexFina = row.LIN_EFEX_FINA;
                model.OfeCodTipoTarj = row.COD_TIPO_TARJ;
                model.OfeTipTarj = row.TIP_TARJ;
                model.OfeLinTcFina = row.LIN_TC_FINA;
                model.OfeLinFina = row.LIN_FINA;
                model.ammountCoco = this.amountcocoValidte;
                model.ofeModoActivacionTC = row.modoactivacionTC;
                model.ofeCodTipOferta = row.typeOfferTC;
                model.offersearchdate = row.offersearchdate;
                model.offeNumCuenta = (producto.Codigo == AppConstants.Products.IL || producto.Codigo == AppConstants.Products.CAMBPROD) ? row.NUM_CUEN : "";
                model.ofeLinComprasIniA = (producto.Codigo == AppConstants.Products.IL) ? row.LINEA_ACTUAL : "";
                model.ofeLinEfexIniA = (producto.Codigo == AppConstants.Products.IL) ? row.LINEA_NUEVA : "";
                if (producto.Codigo == AppConstants.Products.CAMBPROD){
                  sessionStorage.setItem('CAMBPROD', this.newDesCard);
                  model.OfProductReferenceCP = this.valCamProd;
                  model.OfProductDescriptionCP = this.newDesCard;
                  model.OfmethodAutorizationCP = AppConstants.ObjectCliente.BIOMETRICA;
                  model.ofnombreTCAntigua = this.actDesCard;
                  model.panTCAntigua = this.actNroCard;
                }

                if (this.currentTcFlujo) {
                    model.codeFlowTcRemissionReactivationSpecial = this.currentTcFlujo.tabDetCode001;
                    model.returnOption = this.currentTcFlujo.optionSelected;
                    model.returnOption = this.currentTcFlujo.optionSelected;
                    model.altaConRemision = this.currentTcFlujo.tabDetCode006;
                    if (this.currentTcFlujo.previousCard) {
                        model.previousContract = this.currentTcFlujo.previousCard.contrato;
                        model.previousTcNumber = this.currentTcFlujo.previousCard.numeroTarjetaOfuscado;
                    }
                    if (this.currentTcFlujo.previousCardDetail)
                        model.debtAmount = this.currentTcFlujo.previousCardDetail.debtTotalTc;
                }

                this.loading = true;
                this.clientService.createClientCappta(model).subscribe((response) => {
                    this.loading = false;
                    this.alertaService.showMessage(AppConstants.TitleModal.ADD_CLIENT, AppConstants.MessageModal.ADD_CLIENT_MESSAGE_OK, MessageSeverity.success);
                    cliente.NumeroSolicitud = response.solId;
                    cliente.WFInstance = response.wfInstance;
                    producto.Nombre = (this.nameProductCappta + ' ' + row.modoactivacion).trim();
                    sessionStorage.setItem(AppConstants.ObjectCliente.CLIENTE, JSON.stringify(cliente));
                    sessionStorage.setItem(AppConstants.ObjectCliente.PRODUCTO, JSON.stringify(producto));
                    sessionStorage.setItem(AppConstants.ObjectCliente.ENTIDADCONVENIO, '[]');
                    this.redirectDetails(producto.Codigo);
                    console.log(response.solId);
                },
                    (error: HttpErrorResponse) => {
                        this.loading = false;
                        this.alertaService.showMessage(AppConstants.TitleModal.ADD_CLIENT, error.error.messages, MessageSeverity.error);
                    });

            } else {

                var model = new CreateClientCappta();
                model.clientApePat = this.apellidoPaternoCliente;
                model.clientApeMat = this.apellidoMaternoCliente;
                model.clientNombres = this.nombre1Cliente;
                model.clieMiddleName = this.SecondNameClient;
                model.clientDocumemtType = this.documentTyperForm;
                model.clientDocumemtNumber = this.numerodocumento;
                model.clieMail = this.emailCliente;
                model.clientFechaNac = this.fecNacCliente;
                model.situacion = this.politicaCode;
                model.solCountry = AppConstants.SolicitudParameter.SOL_PAIS;
                model.solCurrency = row.tipoMoneda;
                model.solEnterprise = AppConstants.SolicitudParameter.SOL_EMP;
                model.offerCodProd = row.codigoproducto;
                model.offerId = row.idproducto;
                model.offerModAct = row.modoactivacion;
                model.offerValidityStart = row.fechaInicio;
                model.offerValidityEnd = row.fechaFin;
                model.offerAmountMin = row.offerMontMin;
                model.offerAmountMax = row.offerMontMax;
                model.ProcessId = AppConstants.Process.ONBOARDING;
                model.TaskId = AppConstants.WFTareas.EVA_PRODUCT;
                model.Channel = !this.platform.is('cordova') ? AppConstants.Channel.WEB : AppConstants.Channel.MOVIL;
                model.offeCodigoBase = row.codprodBase;

                model.OfeLinEfexFina = row.LIN_EFEX_FINA;
                model.OfeCodTipoTarj = row.COD_TIPO_TARJ;
                model.OfeTipTarj = row.TIP_TARJ;
                model.OfeLinTcFina = row.LIN_TC_FINA;
                model.OfeLinFina = row.LIN_FINA;
                model.ammountCoco = this.amountcocoValidte;
                model.ofeModoActivacionTC = row.modoactivacionTC;
                model.ofeCodTipOferta = row.typeOfferTC;
                model.offersearchdate = row.offersearchdate;
                model.offeNumCuenta = (producto.Codigo == AppConstants.Products.IL || producto.Codigo == AppConstants.Products.CAMBPROD) ? row.NUM_CUEN : "";
                model.ofeLinComprasIniA = (producto.Codigo == AppConstants.Products.IL) ? row.LINEA_ACTUAL : "";
                model.ofeLinEfexIniA = (producto.Codigo == AppConstants.Products.IL) ? row.LINEA_NUEVA : "";
                if (producto.Codigo == AppConstants.Products.CAMBPROD){
                  sessionStorage.setItem('CAMBPROD', this.newDesCard);
                  model.OfProductReferenceCP = this.valCamProd;
                  model.OfProductDescriptionCP = this.newDesCard;
                  model.OfmethodAutorizationCP = AppConstants.ObjectCliente.BIOMETRICA;
                  model.ofnombreTCAntigua = this.actDesCard;
                  model.panTCAntigua = this.actNroCard;
                }

                if (this.currentTcFlujo) {
                    model.codeFlowTcRemissionReactivationSpecial = this.currentTcFlujo.tabDetCode001;
                    model.returnOption = this.currentTcFlujo.optionSelected;
                    model.returnOption = this.currentTcFlujo.optionSelected;
                    model.altaConRemision = this.currentTcFlujo.tabDetCode006;

                    if (this.currentTcFlujo.previousCard)
                        model.previousContract = this.currentTcFlujo.previousCard.contrato;

                    if (this.currentTcFlujo.previousCardDetail)
                        model.debtAmount = this.currentTcFlujo.previousCardDetail.debtTotalTc;
                }


                this.loading = true;
                this.clientService.createClientCappta(model).subscribe((response) => {
                    this.loading = false;
                    this.alertaService.showMessage(AppConstants.TitleModal.ADD_CLIENT, AppConstants.MessageModal.ADD_CLIENT_MESSAGE_OK, MessageSeverity.success);
                    cliente.NumeroSolicitud = response.solId;
                    cliente.WFInstance = response.wfInstance;
                    producto.Nombre = (this.nameProductCappta + ' ' + row.modoactivacion).trim();
                    sessionStorage.setItem(AppConstants.ObjectCliente.CLIENTE, JSON.stringify(cliente));
                    sessionStorage.setItem(AppConstants.ObjectCliente.PRODUCTO, JSON.stringify(producto));
                    sessionStorage.setItem(AppConstants.ObjectCliente.ENTIDADCONVENIO, '[]');
                    this.redirectDetails(producto.Codigo);
                },
                    (error: HttpErrorResponse) => {
                        this.loading = false;
                        this.alertaService.showMessage(AppConstants.TitleModal.ADD_CLIENT, error.error.messages, MessageSeverity.error);
                    });
            }
        } else {
            if (this.productsSimulation.filter(f => f.tabDetCode001 == row.codigoproducto && f.tabDetState == AppConstants.StateFlag.ActivoString && f.tabDetCode006 == AppConstants.LOAN.REEGANCHE).length > 0) {
                if (row.codigoproducto == AppConstants.Products.REENGANCHESEF) {
                    if (row.indicadorOrigenSef === '1') {
                        this.router.navigateByUrl('simulacion/reschedulesef');
                        return;
                    }
                }
                await this.ValidationOfferReeganche(producto);
            } else if (this.productsSimulation.filter(f => f.tabDetCode001 == row.codigoproducto && f.tabDetState == AppConstants.StateFlag.ActivoString && f.tabDetCode006 == AppConstants.LOAN.REPROGRAMACIONES).length > 0) {
                this.router.navigateByUrl('simulacion/reprogramming');
            } else if (this.productsSimulation.filter(f => f.tabDetCode001 == row.codigoproducto && f.tabDetState == AppConstants.StateFlag.ActivoString && f.tabDetCode006 == AppConstants.LOAN.REPROGRAMACIONESSEF).length > 0 || this.productsSimulation.filter(f => f.tabDetCode001 == row.codigoproducto && f.tabDetState == AppConstants.StateFlag.ActivoString && f.tabDetCode006 == AppConstants.LOAN.SEFPLUS).length > 0) {
                this.router.navigateByUrl('simulacion/reprogrammingsef');
            } else {
                this.router.navigateByUrl('simulacion');
            }

        }
    }

    redirectDetails(codigoProducto:string){
      if(codigoProducto == AppConstants.Products.IL){
        this.router.navigateByUrl('productsList/lineIncrement');
      } else if (codigoProducto == AppConstants.Products.CAMBPROD){
        this.router.navigateByUrl('productsList/cambioProd');
      } else {
        this.router.navigateByUrl('clienteDetails');
      }
    }

    valdiateContinueSimulation(productCode: string) {
        if (this.politicaCodeResponse == '000' || this.politicaCodeResponse == '001') {
            if (this.listPerfilsRestrictionPEP.length > 0 && this.politicaCodeResponse == '001') {
                this.alertaService.showMessage(AppConstants.TitleModal.CONSULT_OFFER_RUO, AppConstants.MessageModal.ERROR_RESTRICTITION_CLIENT_PEP, MessageSeverity.error);
            }
            else {
                return true;
            }

        } else {
            return this.products.filter(f => f.tabDetCode001 == productCode && f.tabDetCode005 == AppConstants.StateFlag.Activo && f.tabDetState == AppConstants.StateFlag.ActivoString).length > 0 ? true : false;
        }
    }

    getProductsSimulation(code: number) {
        this.loading = true;
        this.parameterService.getParameters(code).subscribe((response) => {
            this.productsSimulation = response;
            this.loading = false;
        },
            (error: HttpErrorResponse) => {
                this.loading = false;
            });
    }

   // async getUserAgency() {
    //     let request = {
    //         documentNumber: sessionStorage.getItem(AppConstants.Session.USERID)
    //     };
    //     this.loading = true;
    //     await this.onboardingIntegrationService.getUserAgency(request).toPromise().then(async (response) => {
    //         this.conditionAccesFlujo = true;
    //         if (response.agencyCode != sessionStorage.getItem(AppConstants.Session.AGENCYCODE)) {
    //             await this.UpdateAgencyUser(response.agencyCode, response.agencyName);
    //         }
    //         this.loading = false;
    //     },
    //         (error: HttpErrorResponse) => {
    //             this.conditionAccesFlujo = false;
    //             this.loading = false;
    //             this.alertaService.showMessage(AppConstants.TitleModal.VALIDATE_ASESOR, error.error.messages, MessageSeverity.error);
    //         });
    // }

    async validacionAgencia(codigoproducto: string) {
        const request = {
            documentNumber: sessionStorage.getItem(AppConstants.Session.USERID)
        };
        this.loading = true;
            try {
            const response = await this.onboardingIntegrationService.getUserAgency(request).toPromise();
        
            sessionStorage.setItem(AppConstants.Session.AGENCYCODEFROMT24, response.agencyCode);
            // const userRole = sessionStorage.getItem(AppConstants.Session.USERROLID);
    
            if (this.validarProductoRol(codigoproducto)) 
                {
                if (response.agencyCode !== sessionStorage.getItem(AppConstants.Session.AGENCYCODE)) {
                    await this.UpdateAgencyUser(response.agencyCode, response.agencyName);
                }
            }

        } catch (error) {
            // if (error.status === 404) {
            //  this.alertaService.showMessage('Error', 'Agencia no encontrada (404). Verifique el código de la agencia.', MessageSeverity.error);
            //  } 
              console.error('Error en validacionAgencia:', error);
             this.alertaService.showMessage('Advertencia', 'No se pudo obtener el codigo de agencia o usuario no esta registrado en T24', MessageSeverity.error);
        } finally {
           
            this.loading = false;
            this.conditionAccesFlujo = true;
            return true;
        }
									 
																																																														
			   
    }

    validarProductoRol(codigoproducto: string): boolean {
        const productItem = this.pValidacionAgenciaProductos.find(f => f.tabDetCode001 === codigoproducto);

        if (!productItem) {
            return false;
        }
        const userRoleId = sessionStorage.getItem(AppConstants.Session.USERROLID);
        return productItem.tabDetCode006.includes(`|${userRoleId}|`);
    }
	

    async GetParameters(array: Array<number>) {
        let modelRequest = { headerId: array };
        this.loading = true;
        await this.parameterService.getParametersList(modelRequest).toPromise().then((response) => {
            this.setVariablesParameters(response);
            this.loading = false;
        },
            (error: HttpErrorResponse) => {
                this.loading = false;
            });
    }

    setVariablesParameters(listParameter: Parameter[]) {
        this.UsersAccesFlujo = listParameter.filter(f => f.tabCabId == AppConstants.ParameterCode.USER_TRANSACCION && f.tabDetState == AppConstants.StateFlag.Activo);
        this.products = listParameter.filter(f => f.tabCabId == AppConstants.ParameterCode.SUB_PRODUCS && f.tabDetState == AppConstants.StateFlag.Activo);
        this.productsSimulation = listParameter.filter(f => f.tabCabId == AppConstants.ParameterCode.SIMULACIONPYOFF && f.tabDetState == AppConstants.StateFlag.Activo);
        this.cardCambioProd = listParameter.filter(f => f.tabCabId == AppConstants.ParameterCode.CAMBIO_PRODUCTO_TC && f.tabDetState == AppConstants.StateFlag.Activo);
        this.offerCondiguration = listParameter.filter(f => f.tabCabId == AppConstants.ParameterCode.OFFER_DINAMICA && f.tabDetState == AppConstants.StateFlag.Activo);
        this.variablesControl = listParameter.filter(f => f.tabCabId == AppConstants.ParameterCode.VARIABLE_CONTROL_HEADER && f.tabDetState == AppConstants.StateFlag.Activo);
        this.productosPerfil = listParameter.filter(f => f.tabCabId == AppConstants.ParameterCode.PRODUCTOS_PERFIL && f.tabDetCode001 == this.userRolId && f.tabDetState == AppConstants.StateFlag.Activo);
        let amountCoco = listParameter.filter(f => f.tabCabId == AppConstants.ParameterCode.COCO_PARAMETROS && f.tabDetCode001 == AppConstants.StateFlag.ActivoString && f.tabDetState == AppConstants.StateFlag.Activo);
        this.amountcocoValidte = amountCoco.length > 0 ? (isNaN(amountCoco[0].tabDetCode006 as any) ? 0 : parseInt(amountCoco[0].tabDetCode006)) : 0;
        this.listPerfilsRestrictionPEP = listParameter.filter(f => f.tabCabId == AppConstants.ParameterCode.RESTRICCION_VENTA_CLIENT_PEP && f.tabDetCode001 == this.userRolId && f.tabDetState == AppConstants.StateFlag.Activo);
        this.listAgenciasPermitidasVentaTC = listParameter.filter(f => f.tabCabId == AppConstants.ParameterCode.VALIDACION_VENTA_TC_AGENCIA && f.tabDetCode001 == AppConstants.Products.CAPTACION && f.tabDetState == AppConstants.StateFlag.Activo)[0]["tabDetCode006"] === '' ? [] :
            listParameter.filter(f => f.tabCabId == AppConstants.ParameterCode.VALIDACION_VENTA_TC_AGENCIA && f.tabDetCode001 == AppConstants.Products.CAPTACION && f.tabDetState == AppConstants.StateFlag.Activo)[0]["tabDetCode006"] === null ? [] :
                listParameter.filter(f => f.tabCabId == AppConstants.ParameterCode.VALIDACION_VENTA_TC_AGENCIA && f.tabDetCode001 == AppConstants.Products.CAPTACION && f.tabDetState == AppConstants.StateFlag.Activo)[0]["tabDetCode006"].split('|');

        this.listTypeOfferTC = listParameter.filter(f => f.tabCabId == AppConstants.ParameterCode.TIPO_OFERTA_TC && f.tabDetState == AppConstants.StateFlag.Activo);
        this.listSubProductTC = listParameter.filter(f => f.tabCabId == AppConstants.ParameterCode.SUB_PRODUCTOS_TC && f.tabDetState == AppConstants.StateFlag.Activo);
        this.listTcRemisionReactivacionEspecial = listParameter.filter(f => f.tabCabId == AppConstants.ParameterCode.TC_REMISION_REACTIVACION_ESPECIAL && f.tabDetState == AppConstants.StateFlag.Activo);
        this.listOptionReemision = listParameter.filter(f => f.tabCabId == AppConstants.ParameterCode.REEMISION_OPCIONES && f.tabDetState == AppConstants.StateFlag.Activo);
        this.rangoDiasAtrasoTC = listParameter.filter(f => f.tabCabId == AppConstants.ParameterCode.DIAS_ATRASO_TC && f.tabDetState == AppConstants.StateFlag.Activo);
        this.profilesConsultSimulation = listParameter.filter(f => f.tabCabId == AppConstants.ParameterCode.ROLES_BLOQUEAR_SIMULACION && f.tabDetState == AppConstants.StateFlag.Activo && f.tabDetCode001 == this.userRolId);
        if (this.profilesConsultSimulation.length > 0) {
            if (this.profilesConsultSimulation[0]["tabDetCode006"] != null) {
                this.productsAllow = this.profilesConsultSimulation[0]["tabDetCode006"].split('|');
            }
        }

        this.pValidacionAgenciaProductos=listParameter.filter(f => f.tabCabId == AppConstants.ParameterCode.VALIDACION_AGENCIA_PRODUCTOS && f.tabDetState == AppConstants.StateFlag.Activo);


    }

    async validateFlujoAcces(codigoproducto:string) {
        if (this.UsersAccesFlujo.filter(f => f.tabDetCode002 == sessionStorage.getItem(AppConstants.Session.USERID)).length > 0) {
            this.conditionAccesFlujo = true;
            return this.conditionAccesFlujo;
        } else {
            await this.validacionAgencia(codigoproducto);
            return this.conditionAccesFlujo;
        }
    }

    async UpdateAgencyUser(code: string, name: string) {
        let model = { agencyCode: code, userId: '' };
        await this.userService.updateAgency(model).toPromise().then((response) => {
            sessionStorage.setItem(AppConstants.Session.AGENCYCODE, code);
            sessionStorage.setItem(AppConstants.Session.AGENCYNAME, name);
            this.agencyCode = sessionStorage.getItem(AppConstants.Session.AGENCYCODE);
            this.agencyName = sessionStorage.getItem(AppConstants.Session.AGENCYNAME);
        },
            (error: HttpErrorResponse) => {
                this.alertaService.showMessage(
                    AppConstants.TitleModal.ERROR_UPDATEUSER_AGENCY, 
                    error.error.messages, 
                    MessageSeverity.error
                );
            });
    }

    showMessage() {
        showMessage();
    }

    hideMessage() {
        hideMessage();
    }

    async ValidationOfferReeganche(producto: Producto) {
        let modelRequest = { offerId: producto.IdProducto, currenc: producto.TipoMoneda };
        this.loading = true;
        await this.solicitudService.validateOfferReeganche(modelRequest).toPromise().then((response) => {
            if (response.offerTotalSolicitud > 0) {
                this.alertaService.showMessage(AppConstants.TitleModal.VALIDACION_OFFER_REENGANCHE, response.message, MessageSeverity.warn);
            }

            producto.OfferNumReenganches = response.offerTotalSolicitud;
            producto.OfferMontoMaximoReenganche = response.ammountFree;
            producto.OfferMessageReenganche = response.message;
            sessionStorage.setItem(AppConstants.ObjectCliente.PRODUCTO, JSON.stringify(producto));
            this.loading = false;

            this.router.navigateByUrl('simulacion/loan');
        },
            (error: HttpErrorResponse) => {
                this.loading = false;
                this.alertaService.showMessage(AppConstants.TitleModal.VALIDACION_OFFER_REENGANCHE, AppConstants.MessageModal.ERROR_VALIDATE_OFFER, MessageSeverity.error);
            });
    }


    getAmountCoco() {
        this.loading = true;
        this.onboardingIntegrationService.getAmountCoco().subscribe((response) => {
            this.amountcocoValidte = response.ammountCoco;
        },
            (error: HttpErrorResponse) => {
                this.alertaService.showMessage(AppConstants.TitleModal.REGLA_NEGOCIO_COCO, error.error.messages, MessageSeverity.error);
            });
    }

    getValueWilcard(keyvalue: string, comodines: any) {
        let result = '';
        Object.keys(comodines).forEach(key => {
            let ssss = comodines[key]['Key'];
            if (comodines[key]['Key'] == keyvalue) {
                result = comodines[key]['Value'];
            }
        });
        return result;
    }

    validatePEP(productCode: string) {
        if (this.listPerfilsRestrictionPEP.length > 0) {
            let array = this.listPerfilsRestrictionPEP[0]["tabDetCode008"] === '' ? [] : this.listPerfilsRestrictionPEP[0]["tabDetCode008"] === null ? [] : this.listPerfilsRestrictionPEP[0]["tabDetCode008"].split('|');
            if (array.filter(f => f === productCode).length > 0) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }

    getValueReferenceParameter(keyOffer: string, numberParameter: number) {
        let result = '';

        try {

            let validation = (keyOffer == null || keyOffer == undefined || keyOffer == 'undefined') ? false : true;

            if (validation) {
                switch (numberParameter) {

                    case AppConstants.ParameterCode.TIPO_OFERTA_TC: {
                        result = this.listTypeOfferTC.find(f => f.tabDetCode001.trim() == keyOffer.trim()).tabDetCode002;
                        break;
                    }
                    case AppConstants.ParameterCode.SUB_PRODUCTOS_TC: {
                        result = this.listSubProductTC.find(f => f.tabDetCode001.trim() == keyOffer.trim()).tabDetCode002;
                        break;
                    }
                    default: {
                        break;
                    }
                }
            }

        } catch (error) {
            console.log(error);
        }

        return result;
    }

    procesarRedireccionamiento(response: any) {
        sessionStorage.setItem(AppConstants.ObjectCliente.VARIABLE_CONTROL, JSON.stringify(response.body.variableControl));
        var cliente = new Cliente();
        cliente.NumeroSolicitud = response.body.solId;
        cliente.WFInstance = response.body.wfInstance;
        cliente.userCreation = response.body.userCreation;
        sessionStorage.setItem(AppConstants.ObjectCliente.CLIENTE, JSON.stringify(cliente));
        var producto = new Producto();
        producto.Nombre = response.body.producto.nombre;
        producto.Activacion = response.body.producto.activacion;
        producto.Codigo = response.body.producto.codigo;
        producto.Saldo = +response.body.producto.saldo;
        producto.BASE_ORIGEN = response.body.producto.baseOrigen;
        producto.Imagen = this.imageBase + 'icon_' + response.body.producto.image;
        producto.Imagen_m = this.imageBase + 'icon_m_' + response.body.producto.image;
        producto.IntentosToken = response.body.producto.intentosToken;
        producto.indicadorOrigenSef = response.body.producto.indicadorOrigenSef;
        producto.PER_GRAC = response.body.producto.ofeGracePeriodMax;
        sessionStorage.setItem(AppConstants.ObjectCliente.PRODUCTO, JSON.stringify(producto));
        this.createSessionSolicitudBO(producto.Codigo, cliente.NumeroSolicitud);
        this.router.navigateByUrl(response.body.web);
        this.loading = false;

    }

    getValueDiferido(param: string) {
        if (param == "" || param == undefined)
            return "";

        return param == "2" ? "No" : "Si";
    }

    formatPad(valor,tam):string{
      valor = valor.toString();
      while(valor.length<tam) valor = '0' + valor;
      return valor;
    }

    createSessionSolicitudBO(codigoProducto: string, solId: string){
      let solicitud = new SolicitudBoSession();
      if(codigoProducto == AppConstants.Products.CAMBPROD)
        solicitud.tipoSolicitud=TipoSolicitudBO.CambioProducto;
      solicitud.solicitudBOId = solId;
      this.solicitudBOService.setSolicitudBoSession(solicitud);
    }
}
